import index1 from "../assets/img/index-programacion.webp";
import index2 from "../assets/img/ventas-altas.webp";
import index3 from "../assets/img/index-cierre-whatsapp.webp";
import index4 from "../assets/img/index-viajes.webp";
import prof0 from "../assets/img/prof-0.webp";
import profcursows from "../assets/img/prof-curso-ws.webp";
import prof1 from "../assets/img/prof-1.webp";
import bonusprogramacion from "../assets/img/bonus-course-programacion.webp";
import bonustalleria from "../assets/img/bonus-course-content.webp";
import bonusliderazgo from "../assets/img/bonus-course-liderazgo.webp";
import bonusimportacion from "../assets/img/bonus-course-importacion.webp";
import bonusimportacionalibaba from "../assets/img/bonus-course-importacion-alibaba.webp";
import bonusmeta from "../assets/img/bonus-course-metaads.webp";
import introdprog from "../assets/img/introd-programacion.webp"
import talleria from "../assets/img/Banner2CourseContentIA.webp"
import metaads from "../assets/img/metaads.jpg"
import paginasweb from "../assets/img/paginas-web.webp"
import paginaswebnoexpertos from "../assets/img/paginas-web-noexpertos.webp"
import resinEpoxica from "../assets/img/resina-epoxica.webp";
import prodLocucion from "../assets/img/prod-locucion.webp";
import liderazgo from "../assets/img/liderazgo.webp";
import liderazgointerno from "../assets/img/liderazgointerno.webp";
import importacion_1688 from "../assets/img/importacion_1688.webp";
import importacion_alibaba from "../assets/img/importacion_alibaba.jpg";
import logo_importacion_1688 from "../assets/img/logo_importacion_1688.webp";
import logo_importacion_alibaba from "../assets/img/logo_importacion_alibaba.webp";
import bonusebook from "../assets/img/ebook-programacion.webp";
import bannerSuperiorProgramacion from "../assets/img/BannerCourseProgram.webp";
import bannerInferiorProgramacion from "../assets/img/Banner2CourseProgram.webp";
import bannerSuperiorLiderazgo from "../assets/img/BannerCourseLider.webp";
import bannerInferiorLiderazgo from "../assets/img/Banner2CourseLider.webp";
import bannerSuperiorContentIA from "../assets/img/BannerCourseContentIA.webp";
import bannerInferiorContentIA from "../assets/img/Banner2CourseContentIA.webp";

const CourseData = [
  {
    id: "1",
    titleMain: "Aprende programación de software con Javascript",
    title: [
      { "text": "Aprende", "style": { /*"color": "#1e1e1e",*/ "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "programación de software", "style": { "color": "#004AAD", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "con", "style": { /*"color": "#1e1e1e",*/ "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "Javascript", "style": { "color": "#ff3b3b", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 59, 59, 0.5)" } },
      { "text": "🔥💻", "style": { "color": "#333", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Sin experiencia previa y con acceso 100% online. Casi 650 alumnos ya estan viendo resultados en programación con éste curso",
    certifiedStudents: "+523 estudiantes ya estan escribiendo código con este curso",
    //   certifiedStudents: "PROMO FLASH SÓLO POR HOY 🔥",
    startDate: "Ingresas al siguiente día de la inscripción",
    students: 655,
    imageIndex: index1,
    image: introdprog,
    ebook: bonusebook,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.9,
    reviews: 588,
    hook: [
      { "text": "Aprende las bases reales de la", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "programación con un método práctico💻.", "style": { "color": "red", "fontWeight": "bold" } },
      { "text": "Diseñado para principiantes que", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "quieren resultados, no frustraciones", "style": { "color": "rgb(45, 46, 80)", "fontWeight": "bold" } },
    ],
    // hookMain: "🎉Precio de cierre de inscripciones🚀ÚLTIMOS CUPOS 👇 ¿Vas a dejar pasar esta oferta?",
    hookMain: "TU FUTURO EN PROGRAMACIÓN PUEDE INICIAR HOY🔥",
    //hookHeadband: "MIENTRAS OTROS SIGUEN ESPERANDO EL 'MOMENTO PERFECTO', TÚ PUEDES ESTAR YA CONSTRUYENDO TU FUTURO COMO PROGRAMADOR",
    hookHeadband: "¿TE IMAGINAS DOMINAR LAS BASES DE LA PROGRAMACIÓN EN 4 SEMANAS? ¡TÚ TAMBIÉN PUEDES!",
    botonHookText: "¡Quiero Inscribirme!",
    SenseUrgency: "VALOR DEL CURSO + BONOS INCLUIDOS",
    orientedTo: [
      "Estás iniciando en carreras como informática, sistemas o computación",
      "Te gusta la tecnología y quieres aprender programación con JavaScript desde cero",
      "¿Eres emprendedor y quieres crear software para ganar más dinero?",
      "Sueñas con trabajar remoto a futuro creando apps, páginas web o videojuegos",
      "Tienes nociones básicas y quieres reforzar tus fundamentos en programación"
    ],
    paintPoints: [
      "Sientes que nunca aprendes, por más que veas videos o leas tutoriales.",
      "La programación te parece demasiado abstracta y complicada para entenderla.",
      "Haz intentado aprender por tu cuenta pero te sientes perdido y sin apoyo.",
      "Sientes que estas perdiendo oportunidades por no saber programar software.",
      "Estudias alguna carrera donde se ve programación y te cuesta mucho aprobarla.",
    ],
    imgBonus: bonusprogramacion,
    bannerSuperior: bannerSuperiorProgramacion,
    bannerInferior: bannerInferiorProgramacion,
    benefits: [
      "🎥 Clases grabadas + sesiones en vivo para resolver tus dudas",
      "🎯 Ejercicios prácticos desde la primera clase",
      "💻 Clases dinámicas e interactivas",
      "📜 CERTIFICADO de asistencia al finalizar",
      "🎁 E-book “Programación para Todos;” de obsequio",
      "🧠 Aprende a programar y a futuro elige tu lenguaje favorito",
      "💻 Acceso a una comunidad de estudiantes y el mentor para apoyo",
      "✔️ Curso orientado a JAVASCRIPT",
    ],
    includedCourse: [
      "Curso 100% online para que puedas ver las clases desde cualquier lugar del mundo",
      "6 Módulos de clases + 1 Módulo BONUS TRACK DE REGALO",
      "Acceso DE POR VIDA a nuestra plataforma PROPIA donde podrás ver las clases a tu ritmo",
      "Oportunidad para resolver dudas y ejercicios con clases en vivo",
      "Ebook práctico 'Programación para Todos;' TOTALMENTE GRATIS",
      "Certificado de asistencia al finalizar el curso",
      // "Conocimiento sumamente valioso para iniciarte en el mundo de la programación con JAVASCRIPT",
    ],
    faq: [
      {
        q: "¿Necesito experiencia previa para tomar el curso?",
        a: "No, en absoluto. El curso está diseñado específicamente para principiantes y te llevará desde los conceptos más básicos hasta temas avanzados. ¡Solo necesitas ganas de aprender!"
      },
      {
        q: "¿Qué tipo de soporte tendré durante el curso?",
        a: "Tendrás acceso a un grupo privado de estudiantes y al instructor para resolver dudas. Además, habrá sesiones de preguntas y respuestas en vivo para asegurar que nadie se quede atrás."
      },
      {
        q: "¿Puedo estudiar el curso a mi ritmo o hay horario de clases?",
        a: "El curso esta pregrabado y puedes acceder a las clases en el horario que tu desees. Sólo las clases en vivo se agendan en grupo y previo acuerdo con tu sección y el facilitador"
      },
    ],
    emergencyStopwatch: false,
    presale: false,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 216000,
        newPrice: 104900, //128900
        currency: "COP",
        presale: [
          { fecha: '16/09', valor: '🔥 100.900' },
          { fecha: '24/09', valor: '😍 109.900' },
          { fecha: '30/09', valor: '🙂 121.900' },
          { fecha: '08/10', valor: '🔷 141.900' },
        ]
      },
      ve: {
        oldPrice: 57900, // 59.9,
        newPrice: 23199, //24.9,
        currency: "Bs",
        presale: [
          { fecha: '16/09', valor: '🔥 3.899' },
          { fecha: '24/09', valor: '😍 4.199' },
          { fecha: '30/09', valor: '🙂 4.499' },
          { fecha: '08/10', valor: '🔷 4.750' },
        ]
      },
      cl: {
        oldPrice: 58500,
        newPrice: 28900,
        currency: "CLP",
        presale: [
          { fecha: '16/09', valor: '🔥 28.900' },
          { fecha: '24/09', valor: '😍 32.900' },
          { fecha: '30/09', valor: '🙂 36.200' },
          { fecha: '08/10', valor: '🔷 43.490' },
        ]
      },
      mx: {
        oldPrice: 950,
        newPrice: 559,
        currency: "MXN",
        presale: [
          { fecha: '16/09', valor: '🔥 659' },
          { fecha: '24/09', valor: '😍 735' },
          { fecha: '30/09', valor: '🙂 769' },
          { fecha: '08/10', valor: '🔷 870' },
        ]
      },
      pe: {
        oldPrice: 189,
        newPrice: 99,
        currency: "PEN",
        presale: [
          { fecha: '16/09', valor: '🔥 89' },
          { fecha: '24/09', valor: '😍 99' },
          { fecha: '30/09', valor: '🙂 112' },
          { fecha: '08/10', valor: '🔷 124' },
        ]
      },
      us: {
        oldPrice: 147,
        newPrice: 49,
        currency: "$",
        presale: [
          { fecha: '16/09', valor: '🔥 49' },
          { fecha: '24/09', valor: '😍 63' },
          { fecha: '30/09', valor: '🙂 99' },
          { fecha: '08/10', valor: '🔷 120' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 0: Bienvenida al curso",
        content: "Bienvenida, conoce qué estudiaremos, recursos, a donde debemos apuntar, reglas y recomendaciones",
        lessons: [
          { id: 1, title: "Hablemos de tecnología", youtubeId: "N9MOjJ9-GF8" },
          { id: 2, title: "Ventajas de trabajar en tecnología", youtubeId: "OnlMRAorcIo" },
          { id: 3, title: "¿Cómo estudiaremos en este curso?", youtubeId: "CAAkoDjh0UM" },
          { id: 4, title: "Beneficios del curso", youtubeId: "ryUoE2GPc7s" },
          { id: 5, title: "Contenido de estudio", youtubeId: "u6_1QFMudKA" },
          { id: 6, title: "¿A donde debemos apuntar?", youtubeId: "mZzhqTqtjiQ" },
          { id: 7, title: "Reglas y recomendaciones", youtubeId: "ILcjZ2Rv8go" },
        ],
      },
      {
        id: 2,
        title: "Módulo 1: Fundamentos de la Programación",
        content: "Aprendamos con prácticas los conceptos básicos de la programación, pensamiento lógico, algoritmos y pensamiento algoritmico.",
        lessons: [
          { id: 8, title: "Conceptos básicos de la programación", youtubeId: "ksHKDzSx0Qk" },
        ],
      },
      {
        id: 3,
        title: "Módulo 2: Variables, Tipos de Datos y Operadores",
        content: "Cómo definir variables, como entenderlas más fácil, cuales tipos de datos hay, como pueden compararse.",
        lessons: [
          { id: 9, title: "Repaso clase pasada", youtubeId: "6NcWtyXa3A0" },
          { id: 10, title: "Entendamos que son variables", youtubeId: "_dqbVGto-4E" },
          { id: 11, title: "Tipos de datos", youtubeId: "Hw76rtGJVTo" },
          { id: 12, title: "Operadores lógicos", youtubeId: "03op78Fk3NA" },
        ],
      },
      {
        id: 4,
        title: "Módulo 3: Flujos de Control",
        content: "Cómo iterar en un conjunto de datos con ciclos y bucles.",
        lessons: [
          { id: 13, title: "Repaso clase pasada", youtubeId: "k4CmL3tWWcQ" },
          { id: 14, title: "Estructuras de control de flujo", youtubeId: "2agBD5oDGN0" },
          { id: 15, title: "Estructura if / if-else", youtubeId: "TBNsjhuGOAA" },
          { id: 16, title: "Ciclo Mientras", youtubeId: "2Rx_t6FCBtk" },
          { id: 17, title: "Ciclo Hacer-Mientras", youtubeId: "1MFAokd9M8I" },
          { id: 18, title: "Ciclo Para", youtubeId: "KQWRto4Sq9k" },
        ],
      },
      {
        id: 5,
        title: "Módulo 4: Estructuras de Datos y Arrays",
        content: "Como entender a la perfección los arreglos, como se usan, y buenas prácticas con estructuras de datos.",
        lessons: [
          { id: 19, title: "Llamado de atención del curso", youtubeId: "8A2netOvTT8" },
          { id: 20, title: "Ejercicios clase pasada", youtubeId: "nRlnoOmv1x8" },
          { id: 21, title: "Estructuras de datos", youtubeId: "dSJ7930lDpA" },
          { id: 22, title: "Manipulación de datos con arrays", youtubeId: "VmWadLAjlMs" },
        ],
      },
      {
        id: 6,
        title: "Módulo 5: Funciones y Código Limpio",
        content: "Como optimizar mi código con funciones, reutilización de código y principios de código limpio en javascript.",
        lessons: [
          { id: 23, title: "Repaso clase pasada", youtubeId: "P8gB9dxC0uM" },
          { id: 24, title: "¿Qué es código limpio? Características", youtubeId: "4OngQbN6p7k" },
          { id: 25, title: "Principios del código limpio", youtubeId: "g7HA_-LROFc" },
          { id: 26, title: "Funciones", youtubeId: "wfAcULLIX00" },
          { id: 27, title: "Manejo de funciones en JavaScript", youtubeId: "L-75e-cTLuM" },
        ],
      },
      {
        id: 7,
        title: "Módulo 6: Programación Orientada a Objetos (POO)",
        content: "Para qué sirve la POO, como me ayuda a la hora de programar, como estructuro mis proyectos. Aplicación práctica.",
        lessons: [
          { id: 28, title: "Repaso clase pasada", youtubeId: "lcrB2ZnSdUs" },
          { id: 29, title: "¿Qué es la POO?", youtubeId: "kcqkzmrPd6o" },
          { id: 30, title: "Objetos y clases", youtubeId: "q2rw84SKM4Y" },
          { id: 31, title: "Propiedades y métodos", youtubeId: "giyaYpejw2c" },
          { id: 32, title: "Ejemplos en javascript", youtubeId: "5PrZaMOxTRA" },
          { id: 33, title: "Constructores", youtubeId: "Kcawk6mqjHY" },
          { id: 34, title: "Herencia", youtubeId: "JuCw-AYnS2U" },
          { id: 35, title: "Polimorfismo", youtubeId: "QsiikljBDRg" },
          { id: 36, title: "Prácticas de POO", youtubeId: "YuLzQTIqXXE" },
        ],
      },
      {
        id: 8,
        title: "Módulo 7: BONUS TRACK (Regalo)",
        content: "Como resolver cualquier duda de programación con IA, como programar con IA, como hacer sitios web con IA",
        lessons: [
          { id: 31, title: "¿Qué es la IA?", youtubeId: "rhA1w_5qkBs" },
          { id: 32, title: "¿Qué es ChatGPT?", youtubeId: "quaGdPSkOfQ" },
          { id: 33, title: "¿Cómo usar la IA para programar?", youtubeId: "bfFHx8yy1J8" },
        ],
      },
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Ingeniero en informática con más de 8 años de experiencia como desarrollador full stack y profesor del área de software de diferentes áreas. Dinámico, proactivo y dispuesto a entregar todo su conocimiento a la comunidad...",
      image: prof0,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "Acceso inmediato + certificado incluido",
      testimony1: "La manera como se da el material es sumamente entendible. Me encantó. — Sofía, 32 años",
      testimony2: "Aprendí bastante, superó mis expectativas. Sobre todo la programación con IA. — Rosa, 33 años",
      includedCourse: [
        "Acceso inmediato al curso completo",
        "6 Módulos de clases + 1 Módulo BONUS TRACK DE REGALO",
        "Acceso DE POR VIDA a nuestra plataforma PROPIA",
        "Ebook práctico 'Programación para Todos;' TOTALMENTE GRATIS",
        "Certificado de asistencia al finalizar",
        "Garantía de satisfacción incluida",
      ],
      bottomHook: "Con este curso aprenderás programación si o si.",
      topHook: "Curso diseñado para aprender de manera práctica y dinámica"
    },
    active: true,
    openRegistrations: true
  },
  {
    id: "2",
    titleMain: "El Secreto para tener Ventas Imparables: Meta Ads",
    title: [
      { "text": "🚀 El Secreto", "style": { "color": "#1e1e1e", "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "para tener", "style": { "color": "#1e1e1e", "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "Ventas Imparables: Meta Ads", "style": { "color": "#ff3b3b", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 59, 59, 0.5)" } },
      { "text": "🔥", "style": { "color": "#333", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Domina la publicidad en Meta Ads y aprende a generar ventas de manera predecible y escalable.",
    startDate: "Lunes 2 Febrero, 2026",
    students: 55,
    imageIndex: index2,
    image: metaads,
    duration: "1 ½ mes - 2 días semanal",
    mode: "100% ONLINE. Las clases se publican los lunes y miércoles. Todas estarán grabadas y quedan disponibles para ser vistas en cualquier momento. Además, tendremos sesiones de consultas EN VIVO.",
    certifiedStudents: "+ 650 estudiantes ya estan viendo resultados",
    rating: 4.7,
    reviews: 15,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 310500,
        newPrice: 210900,
        currency: "COP"
      },
      ve: {
        oldPrice: 30090,//85,
        newPrice: 18400, //52.7
        currency: "Bs"//"$"
      },
      cl: {
        oldPrice: 79000,
        newPrice: 48000,
        currency: "CLP"
      },
      mx: {
        oldPrice: 1540,
        newPrice: 1049,
        currency: "MXN",
      },
      us: {
        oldPrice: 210,
        newPrice: 119,
        currency: "$"
      }
    },
    hook: [
      { text: "💰🚀 Aprende estrategias probadas para", "style": { "color": "black", "fontWeight": "normal" } },
      { text: "convertir interesados en ventas reales", "style": { "color": "red", "fontWeight": "bold" } },
      { text: "con Meta Ads.", "style": { "color": "black", "fontWeight": "normal" } },
      { text: "¡Domina la publicidad digital y haz crecer tu negocio YA! 📈", "style": { "color": "rgb(45, 46, 80)", "fontWeight": "bold" } }
    ],
    emergencyStopwatch: false,
    hookMain: "🎉 Te felicito por interesarte en este curso. 🚀 Estás a un paso de convertirte en un experto en Meta Ads y potenciar tus ventas.",
    hookHeadband: "¿QUIERES DUPLICAR TUS VENTAS CON PUBLICIDAD DIGITAL?",
    botonHookText: "QUIERO AUMENTAR MIS VENTAS",
    SenseUrgency: "¡SÓLO 5 CUPOS CON ESTE DESCUENTO!",
    orientedTo: [
      "Emprendedores que desean aumentar sus ventas y posicionar su marca",
      "Dueños de negocios que quieren aprender a vender más con publicidad digital",
      "Marketers que buscan dominar Meta Ads y potenciar su estrategia",
      "Freelancers que desean ofrecer servicios de anuncios pagos y atraer clientes",
      "Personas que han probado Meta Ads sin éxito y quieren aprender estrategias efectivas"
    ],
    imgBonus: bonusmeta,
    benefits: [
      "🎥 Clases 100% online con acceso ilimitado",
      "🎯 Aprenderás desde 0 hasta convertirte en un experto en Meta Ads",
      "📜 Certificado de asistencia al finalizar",
      "🎁 Manual 'Algunos hooks potentes para generar ventas imparables' como obsequio GRATIS",
      "💰 Aprende a escalar anuncios sin perder dinero en pruebas"
    ],
    includedCourse: [
      "Curso práctico con lecciones grabadas y sesiones en vivo",
      "Acceso a una comunidad exclusiva de estudiantes",
      "Manual 'Algunos hooks potentes para generar ventas imparables' totalmente GRATIS",
      "Certificado de asistencia al finalizar el curso",
      "Técnicas avanzadas para mejorar el retorno de inversión en publicidad"
    ],
    instructor: {
      name: "Luis E Nieto",
      bio: "Ing. en Informática y especialista en Ventas con Meta Ads, generando estrategias rentables para negocios digitales...",
      image: prof0,
      profession: "ING. EN INFORMÁTICA"
    },
    paymentMethods: {
      ve: "PAGO MÓVIL BANCARIO - BCV",
      co: "Tarjeta de crédito. Tarjeta de débito.  Transferencia Nequi y Bancolombia. Efecty",
      default: "Tarjeta de crédito. Tarjeta de débito. Transferencias bancarias directas"
    },
    modules: [
      {
        id: 1,
        title: "Módulo 1: Fundamentos de Meta Ads",
        content: "Comprenderás cómo funciona la plataforma de anuncios de Meta y los principios básicos de la publicidad digital."
      },
      {
        id: 2,
        title: "Módulo 2: Análisis del Público y Fases de Venta",
        content: "Identificarás las diferentes audiencias y cómo estructurar anuncios en cada etapa del embudo de ventas."
      },
      {
        id: 3,
        title: "Módulo 3: Segmentación y Estrategia de Público",
        content: "Aprenderás a definir públicos ideales para cada tipo de producto o servicio, utilizando segmentaciones avanzadas."
      },
      {
        id: 4,
        title: "Módulo 4: Creación de Anuncios Ganadores",
        content: "Descubrirás cómo escribir anuncios atractivos, diseñar creativos efectivos y utilizar estrategias persuasivas para maximizar el CTR."
      },
      {
        id: 5,
        title: "Módulo 5: Presupuesto, Bidding y Optimización",
        content: "Cómo asignar correctamente el presupuesto, interpretar métricas clave y optimizar campañas para obtener el mejor ROI."
      },
      {
        id: 6,
        title: "Módulo 6: Embudos de Venta y Estrategias Avanzadas",
        content: "Aprenderás a estructurar embudos efectivos para captación de clientes y aumentar conversiones con estrategias avanzadas."
      },
      {
        id: 7,
        title: "Módulo 7: Escalamiento y Casos de Estudio",
        content: "Cómo escalar campañas sin aumentar el costo por conversión, además de analizar casos de éxito y estrategias ganadoras."
      }
    ],
    active: true,
    openRegistrations: false
  },
  {
    id: "3",
    titleMain: "Importación Segura para Principiantes con 1688",
    title: [
      { "text": "Importación", "style": { "color": "#1e1e1e", "fontWeight": "normal", "fontSize": "2rem", "WebkitTextStroke": "0.5px white", "textShadow": "0 0 1px white" } },
      { "text": "Segura", "style": { "color": "#FFA500", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "para", "style": { "color": "#1e1e1e", "fontWeight": "normal", "fontSize": "2rem", "WebkitTextStroke": "0.5px white", "textShadow": "0 0 1px white" } },
      { "text": "Principiantes con 1688", "style": { "color": "#FFD700", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 215, 0, 0.6)" } },
      { "text": "📦🚀", "style": { "color": "#FF8C00", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Domina la plataforma de importación desde China más rentable del mercado HOY, comprando productos en 1688.com",
    certifiedStudents: "+ 79 estudiantes ya estan importando desde China",
    startDate: "Lunes 2 de marzo 2026",
    students: 79,
    imageIndex: logo_importacion_1688,
    image: importacion_1688,
    ebook: null,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.8,
    reviews: 78,
    hook: [
      { "text": "Importa desde China a", "style": { "color": "#FFFFFF", "fontWeight": "bold", "fontSize": "clamp(2.5rem, 10vw, 4.5rem)", "textShadow": "0 2px 4px rgba(0, 0, 0, 0.5)" } },
      { "text": "Precios de Fábrica", "style": { "backgroundImage": "linear-gradient(to right, #FBBF24, #F97316)", "WebkitBackgroundClip": "text", "WebkitTextFillColor": "transparent", "backgroundClip": "text", "textFillColor": "transparent", "fontWeight": "bold", "fontSize": "clamp(2.5rem, 10vw, 4.5rem)", "textShadow": "0 2px 4px rgba(0, 0, 0, 0.3)" } }
    ],
    emergencyStopwatch: false,
    // hookMain: "🎉Precio de cierre de inscripciones🚀ÚLTIMOS CUPOS 👇 ¿Vas a dejar pasar esta oferta?",
    hookMain: "Muchos ya estan importando productos desde China ¡NO LO PIENSES MÁS Y ACCEDE YA!",
    //hookHeadband: "MIENTRAS OTROS SIGUEN ESPERANDO EL 'MOMENTO PERFECTO', TÚ PUEDES ESTAR YA CONSTRUYENDO TU FUTURO COMO PROGRAMADOR",
    hookHeadband: "APRENDE A IMPORTAR DESDE CHINA EN POCOS DÍAS Y EVITA LOS ERRORES QUE TE PUEDEN COSTAR CARO.",
    botonHookText: "¡Inscríbete y comienza a importar! 🚀",
    SenseUrgency: "¡Invertir en tu educación es invertir en tu futuro!",
    benefits: [
      "🎥 Clases grabadas sobre la plataforma 1688. Más barata que Temu, Alibaba y AliExpress",
      "📦 Aprende a identificar proveedores confiables y evitar estafas",
      "💰 Descubre cómo importar con poco dinero y comenzar sin experiencia",
      "📲 Acompañamiento directo por WhatsApp para resolver dudas reales",
      "🚚 Aprende a calcular costos y elegir entre envío marítimo o aéreo",
      "🔍 Plantillas y checklists para contactar proveedores sin errores",
      "📜 CERTIFICADO de asistencia al finalizar el curso",
      "🛍️ Ideal para comenzar tu tienda online o negocio físico desde cero",
      "✔️ Curso 100% práctico con ejemplos reales y actuales",
    ],
    orientedTo: [
      "Eres emprendedor y quieres importar productos desde China sin caer en estafas ni perder dinero",
      "Quieres iniciar un negocio online o físico vendiendo productos importados desde 1688",
      "Te gustaría tener una fuente de ingresos estable trayendo productos desde China pero no sabes por dónde empezar",
      "Tienes miedo de hacer tu primera importación y cometer errores costosos por falta de información",
      "Ya has intentado importar pero te confundiste con proveedores, aduanas o métodos de pago",
      "Buscas una guía clara, sin tecnicismos ni rodeos, para importar con éxito",
      "Estás cansado de ver cursos que complican todo y solo quieres un paso a paso real, probado y fácil de aplicar"
    ],
    imgBonus: bonusimportacion,
    includedCourse: [
      "Curso 100% online: Aplica para cualquier país",
      "Acceso DE POR VIDA a nuestra plataforma de estudio",
      "Actualizaciones futuras incluidas",
      "Checklist exclusivo para verificar si un proveedor en 1688 es confiable",
      "Certificado digital al finalizar el curso",
      "Acceso a una comunidad por whatsApp para apoyarte en el proceso",
      "Acompañamiento y asesoría en tu primera compra"
    ],
    presale: false,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 195000,
        newPrice: 99000,
        currency: "COP",
        presale: [
          { fecha: '13/07', valor: '🔥 104.900' },  // Hasta el 11 de julio
          { fecha: '18/07', valor: '😍 124.900' },  // Hasta el 16 de julio
          { fecha: '25/07', valor: '😎 149.000' },  // Hasta el 21 de julio
          { fecha: '28/07', valor: '🚀 185.000' }   // Precio final hasta el día de inicio
        ]
      },
      ve: {
        oldPrice: 16320, // 69.9,
        newPrice: 9990, //31,
        currency: "Bs",
        presale: [
          { fecha: '13/07', valor: '🔥 2.250' },
          { fecha: '18/07', valor: '😍 2.799' },
          { fecha: '25/07', valor: '😎 3.300' },
          { fecha: '28/07', valor: '🚀 3.850' },
        ]
      },
      cl: {
        oldPrice: 48100,
        newPrice: 29500,
        currency: "CLP",
        presale: [
          { fecha: '13/07', valor: '🔥 29.500' },
          { fecha: '18/07', valor: '😍 34.900' },
          { fecha: '25/07', valor: '😎 40.200' },
          { fecha: '28/07', valor: '🚀 48.100' },
        ]
      },
      mx: {
        oldPrice: 645,
        newPrice: 410,
        currency: "MXN",
        presale: [
          { fecha: '13/07', valor: '🔥 500' },
          { fecha: '18/07', valor: '😍 585' },
          { fecha: '25/07', valor: '😎 639' },
          { fecha: '28/07', valor: '🚀 700' },
        ]
      },
      us: {
        oldPrice: 105,
        newPrice: 49,
        currency: "$",
        presale: [
          { fecha: '13/07', valor: '🔥 44' },
          { fecha: '18/07', valor: '😍 59' },
          { fecha: '25/07', valor: '😎 79' },
          { fecha: '28/07', valor: '🚀 105' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 0: Bienvenida al curso",
        content: "Conoce el objetivo del curso, los beneficios y cómo lo estudiaremos para que saques el mayor provecho posible desde el primer día.",
        lessons: [
          { id: 1, title: "¿Qué son las importaciones y por qué 1688?", youtubeId: "" },
          { id: 2, title: "Ventajas de comprar en las fábricas chinas", youtubeId: "" },
          { id: 3, title: "¿Cómo estudiaremos en este curso?", youtubeId: "" },
          { id: 4, title: "Beneficios del curso", youtubeId: "" },
          { id: 5, title: "Contenido de estudio", youtubeId: "" },
          { id: 6, title: "¿A donde debemos apuntar?", youtubeId: "" },
          { id: 7, title: "Reglas y recomendaciones", youtubeId: "" },
        ],
      },
      {
        id: 2,
        title: "Módulo 1: Preparación antes de importar",
        content: "Te vamos a preparar con todas las herramientas necesarias para importar incluso si no tienes empresa.",
        lessons: [
          { id: 8, title: "¿Qué es 1688 y cómo funciona?", youtubeId: "" },
          { id: 9, title: "Consideraciones importantes antes de importar", youtubeId: "" },
          { id: 10, title: "Cómo registrarte para obtener una tarjeta Zinli", youtubeId: "" },
          { id: 11, title: "Cómo crear una cuenta y recargar Binance", youtubeId: "" },
          { id: 12, title: "Cómo recargar Zinli desde Binance", youtubeId: "" },
        ],
      },
      {
        id: 3,
        title: "Módulo 2: Búsqueda y selección de productos en 1688",
        content: "Aprenderás a buscar, analizar y seleccionar productos ganadores y proveedores confiables.",
        lessons: [
          { id: 13, title: "Cómo buscar productos en 1688 como un experto", youtubeId: "" },
          { id: 14, title: "Cómo usar imágenes y palabras clave para buscar", youtubeId: "" },
          { id: 15, title: "Checklist: cómo saber si un proveedor es confiable", youtubeId: "" },
          { id: 16, title: "Cómo calcular el precio final de tus productos", youtubeId: "" },
          { id: 17, title: "Nichos recomendados para principiantes", youtubeId: "" },
        ],
      },
      {
        id: 4,
        title: "Módulo 3: Negociación y compra segura",
        content: "Aprenderás a comunicarte, negociar y hacer tus compras con seguridad y confianza en 1688.",
        lessons: [
          { id: 18, title: "Cómo conversar con el proveedor antes de pagar", youtubeId: "" },
          { id: 19, title: "Plantilla de conversación efectiva con proveedores", youtubeId: "" },
          { id: 20, title: "Cómo evitar estafas comunes en 1688", youtubeId: "" },
          { id: 21, title: "Cómo saber si mi producto es rentable", youtubeId: "" },
        ],
      },
      {
        id: 5,
        title: "Módulo 4: Envío a tu país paso a paso",
        content: "Descubrirás cómo enviar tus productos desde China hasta la puerta de tu casa sin complicaciones.",
        lessons: [
          { id: 22, title: "Cómo crear un casillero con un agente de envíos", youtubeId: "" },
          { id: 23, title: "Cómo enviar los productos desde China a tu país", youtubeId: "" },
          { id: 24, title: "Tipos de envío: aéreo, marítimo, consolidado", youtubeId: "" },
          { id: 25, title: "Cómo pagar productos en 1688 sin tener cuenta en China", youtubeId: "" },
        ],
      }
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Importador con experiencia en compras desde China a través de 1688 y otras plataformas, especializado en procesos de importación sin necesidad de empresa formal. Además, es estratega digital y emprendedor en múltiples áreas del comercio electrónico.",
      image: prof0,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "Importa desde China paso a paso, sin errores ni pérdidas de dinero",
      testimony1: "Pensé que importar era muy complicado, pero ahora ya hice mi primer pedido por 1688 sin miedo. — Carlos, 29 años",
      testimony2: "El curso es súper claro y práctico. Aprendí a negociar con proveedores y calcular costos reales. — Andrea, 35 años",
      includedCourse: [
        "Acceso inmediato al curso completo",
        "4 Módulos paso a paso",
        "Acceso DE POR VIDA a nuestra plataforma PROPIA",
        "Checklist exclusivo para verificar si un proveedor es confiable",
        "Acceso a una comunidad por whatsApp para apoyarte en el proceso",
        "Certificado de asistencia al finalizar",
        "Garantía de satisfacción incluida",
      ],
      bottomHook: "Aprenderás a importar desde 1688 de forma segura, rentable y sin intermediarios innecesarios.",
      topHook: "Curso diseñado para principiantes que quieren importar desde las fábricas en China"
    },
    active: true,
    openRegistrations: true
  },
  {
    id: "4",
    titleMain: "Importación con Alibaba, AliExpress y Temu",
    title: [
      { "text": "Importa productos con", "style": { "color": "#1e1e1e", "fontWeight": "normal", "fontSize": "2rem", "WebkitTextStroke": "0.5px white", "textShadow": "0 0 1px white" } },
      { "text": "Alibaba, ", "style": { "color": "#FFA500", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "AliExpress ", "style": { "color": "#FFD700", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 215, 0, 0.6)" } },
      { "text": "y Temu", "style": { "color": "#FFD700", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 215, 0, 0.6)" } },
      { "text": "📦🚀", "style": { "color": "#FF8C00", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Vas a comprar productos para tu uso personal o para la venta directo desde China. Rápido, seguro y confiable",
    certifiedStudents: "+ 112 estudiantes ya estan viendo resultados",
    startDate: "Lunes 2 de marzo 2026",
    students: 112,
    imageIndex: logo_importacion_alibaba,
    image: importacion_alibaba,
    imgBonus: bonusimportacionalibaba,
    ebook: null,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.8,
    reviews: 112,
    hook: [
      { "text": "📦Importa desde China", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "a los mejores precios y sin miedo de estafas", "style": { "color": "#FFA500", "fontWeight": "bold" } },
      { "text": "aunque no tengas experiencia", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "¡Empieza tu negocio rentable hoy! 🚀", "style": { "color": "#FF3B3B", "fontWeight": "bold" } },
    ],
    emergencyStopwatch: false,
    // hookMain: "🎉Precio de cierre de inscripciones🚀ÚLTIMOS CUPOS 👇 ¿Vas a dejar pasar esta oferta?",
    hookMain: "Muchos ya estan importando mercancía desde China ¡NO LO PIENSES MÁS Y ACCEDE YA!",
    //hookHeadband: "MIENTRAS OTROS SIGUEN ESPERANDO EL 'MOMENTO PERFECTO', TÚ PUEDES ESTAR YA CONSTRUYENDO TU FUTURO COMO PROGRAMADOR",
    hookHeadband: "APRENDE A IMPORTAR DESDE CHINA EN POCOS DÍAS Y EVITA LOS ERRORES QUE TE PUEDEN COSTAR CARO.",
    botonHookText: "¡Inscríbete YA y comienza a importar! 👨‍💻",
    SenseUrgency: "🎉Precio promocional para los primeros inscritos",
    benefits: [
      "🎥 Clases grabadas sobre las plataformas más comunes para importar productos.",
      "📦 Aprende a identificar proveedores confiables y evitar estafas",
      "💰 Descubre cómo importar con poco dinero y comenzar sin experiencia",
      "📲 Acompañamiento directo por WhatsApp para resolver dudas reales",
      "🚚 Aprende a calcular costos y elegir entre envío marítimo o aéreo",
      "🔍 Plantillas y checklists para contactar proveedores sin errores",
      "📜 CERTIFICADO de asistencia al finalizar el curso",
      "🛍️ Ideal para comenzar tu tienda online o negocio físico desde cero",
      "✔️ Curso 100% práctico con ejemplos reales y actuales",
    ],
    orientedTo: [
      "Eres emprendedor y quieres importar productos desde China sin caer en estafas ni perder dinero",
      "Quieres iniciar un negocio online o físico vendiendo productos importados desde 1688",
      "Te gustaría tener una fuente de ingresos estable trayendo productos desde China pero no sabes por dónde empezar",
      "Tienes miedo de hacer tu primera importación y cometer errores costosos por falta de información",
      "Ya has intentado importar pero te confundiste con proveedores, aduanas o métodos de pago",
      "Buscas una guía clara, sin tecnicismos ni rodeos, para importar con éxito",
      "Estás cansado de ver cursos que complican todo y solo quieres un paso a paso real, probado y fácil de aplicar"
    ],
    includedCourse: [
      "Curso 100% online: aprende desde cualquier lugar del mundo y a tu ritmo",
      "Acceso DE POR VIDA a nuestra plataforma de estudio y futuras actualizaciones",
      "Checklist exclusivo para verificar si un proveedor es seguro",
      "Certificado digital al finalizar el curso para respaldar tus conocimientos",
      "Conocimiento probado y directo para que realices tu primera importación con seguridad y sin errores costosos"
    ],
    presale: false,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 195000,
        newPrice: 99000,
        currency: "COP",
        presale: [
          { fecha: '13/07', valor: '🔥 104.900' },  // Hasta el 11 de julio
          { fecha: '18/07', valor: '😍 124.900' },  // Hasta el 16 de julio
          { fecha: '25/07', valor: '😎 149.000' },  // Hasta el 21 de julio
          { fecha: '28/07', valor: '🚀 185.000' }   // Precio final hasta el día de inicio
        ]
      },
      ve: {
        oldPrice: 14320, // 69.9,
        newPrice: 9990, //31,
        currency: "Bs",
        presale: [
          { fecha: '13/07', valor: '🔥 2.800' },
          { fecha: '18/07', valor: '😍 3.390' },
          { fecha: '25/07', valor: '😎 3.900' },
          { fecha: '28/07', valor: '🚀 4.650' },
        ]
      },
      cl: {
        oldPrice: 48100,
        newPrice: 29500,
        currency: "CLP",
        presale: [
          { fecha: '13/07', valor: '🔥 29.500' },
          { fecha: '18/07', valor: '😍 34.900' },
          { fecha: '25/07', valor: '😎 40.200' },
          { fecha: '28/07', valor: '🚀 48.100' },
        ]
      },
      mx: {
        oldPrice: 755,
        newPrice: 500,
        currency: "MXN",
        presale: [
          { fecha: '13/07', valor: '🔥 500' },
          { fecha: '18/07', valor: '😍 585' },
          { fecha: '25/07', valor: '😎 639' },
          { fecha: '28/07', valor: '🚀 700' },
        ]
      },
      us: {
        oldPrice: 105,
        newPrice: 49,
        currency: "$",
        presale: [
          { fecha: '13/07', valor: '🔥 44' },
          { fecha: '18/07', valor: '😍 59' },
          { fecha: '25/07', valor: '😎 79' },
          { fecha: '28/07', valor: '🚀 105' },
        ]
      }
    },
    modules: [
      {
        id: 0,
        title: "Módulo 0: Bienvenida al curso",
        content: "Conoce el objetivo del curso, los beneficios y cómo lo estudiaremos para que saques el mayor provecho posible desde el primer día.",
        lessons: [
          { id: 1, title: "¿Qué son las importaciones y por qué 1688?", youtubeId: "" },
          { id: 2, title: "Ventajas de comprar en las fábricas chinas", youtubeId: "" },
          { id: 3, title: "¿Cómo estudiaremos en este curso?", youtubeId: "" },
          { id: 4, title: "Beneficios del curso", youtubeId: "" },
          { id: 5, title: "Contenido de estudio", youtubeId: "" },
          { id: 6, title: "¿A donde debemos apuntar?", youtubeId: "" },
          { id: 7, title: "Reglas y recomendaciones", youtubeId: "" },
        ],
      },
      {
        id: 1,
        title: "Módulo 1: Fundamentos de la Importación Online",
        content: "En este módulo aprenderás las bases del comercio internacional. Conocerás las diferencias clave entre Alibaba, AliExpress y Temu, aprenderás a crear tarjetas internacionales y descubrirás cómo analizar si un producto es rentable antes de invertir en él.",
        lessons: [
          { id: 8, title: "Introducción al comercio internacional y e-commerce global", youtubeId: "" },
          { id: 9, title: "Diferencias entre Alibaba, AliExpress y Temu", youtubeId: "" },
          { id: 10, title: "Cómo registrarte para obtener una tarjeta Zinli o Wally", youtubeId: "" },
          { id: 11, title: "Cómo crear una cuenta y recargar por Binance", youtubeId: "" },
          { id: 12, title: "Cómo identificar si un producto es rentable (análisis de mercado básico)", youtubeId: "" },
        ],
      },
      {
        id: 2,
        title: "Módulo 2: Alibaba – Compras al por mayor y negociaciones",
        content: "Aquí te adentrarás en Alibaba, la plataforma líder para importaciones al por mayor. Verás cómo encontrar proveedores confiables, negociar precios y cantidades mínimas, optimizar costos.",
        lessons: [
          { id: 13, title: "Cómo crear una cuenta y configurar tu perfil de comprador", youtubeId: "" },
          { id: 14, title: "Búsqueda de proveedores confiables (Gold Supplier, Trade Assurance, Verified Supplier)", youtubeId: "" },
          { id: 15, title: "Cómo negociar con proveedores (mensajes, descuentos, cantidades mínimas)", youtubeId: "" },
          { id: 16, title: "Métodos de pago y seguridad en Alibaba", youtubeId: "" },
          { id: 17, title: "Opciones de envío (marítimo, aéreo, couriers) y costos ocultos", youtubeId: "" },
        ],
      },
      {
        id: 3,
        title: "Módulo 3: AliExpress y Temu – Compras minoristas y modelos híbridos",
        content: "Este módulo está enfocado en importaciones pequeñas y ágiles. Aprenderás a comprar en AliExpress y Temu, aprovechar cupones y descuentos, realizar pruebas de mercado con cantidades reducidas.",
        lessons: [
          { id: 18, title: "Creando tu cuenta y configurando direcciones de envío internacionales", youtubeId: "" },
          { id: 19, title: "Estrategias para importar en pequeñas cantidades con AliExpress y Temu", youtubeId: "" },
          { id: 20, title: "Uso de cupones, descuentos y ofertas flash para aumentar tu margen", youtubeId: "" },
          { id: 21, title: "Cómo aprovechar AliExpress y Temu para dropshipping o pruebas de mercado", youtubeId: "" },
          { id: 22, title: "Análisis de tiempos de entrega, garantías y devoluciones", youtubeId: "" },
        ],
      },
      {
        id: 4,
        title: "Módulo 4: De la compra a la venta – Tu negocio de importación",
        content: "El cierre del curso es totalmente práctico: aprenderás a calcular precios finales, entenderás cómo cumplir con normativas de importación en tu país y explorarás estrategias para crear tu propia marca.",
        lessons: [
          { id: 23, title: "Estrategias para calcular precios finales (costos + impuestos + ganancias)", youtubeId: "" },
          { id: 24, title: "Cómo manejar aduanas, aranceles y normativas de importación en tu país", youtubeId: "" },
          { id: 25, title: "Cómo crear tu propia marca con productos importados", youtubeId: "" },
          { id: 26, title: "Canales de venta recomendados: Marketplace (Amazon, MercadoLibre) y redes sociales", youtubeId: "" },
          { id: 27, title: "Escalando tu negocio: de la primera importación a un emprendimiento estable", youtubeId: "" },
        ],
      }
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Importador con experiencia real en compras desde China a través de 1688 y otras plataformas, especializado en procesos de importación sin necesidad de empresa formal. Además, es estratega digital y emprendedor en múltiples áreas del comercio electrónico.",
      image: prof0,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "Aprende a importar con Alibaba, AliExpress y Temu sin riesgos ni errores costosos",
      testimony1: "Nunca había importado y este curso me dio la seguridad para hacer mi primer pedido sin miedo. — Juan, 31 años",
      testimony2: "Lo mejor fue el checklist de proveedores. Ahora sé exactamente con quién comprar y con quién no. — Mariana, 36 años",
      includedCourse: [
        "Curso 100% online: aprende desde cualquier lugar del mundo y a tu ritmo",
        "Acceso DE POR VIDA a nuestra plataforma de estudio y futuras actualizaciones",
        "Checklist exclusivo para verificar si un proveedor es seguro",
        "Certificado digital al finalizar el curso",
        "Conocimiento probado y directo para que realices tu primera importación con seguridad y sin errores costosos"
      ],
      bottomHook: "Después de este curso sabrás importar de forma segura usando Alibaba, AliExpress y Temu, incluso si empiezas desde cero.",
      topHook: "Curso diseñado para principiantes que quieren importar sin intermediarios y sin perder dinero"
    },
    active: true,
    openRegistrations: true
  },
  {
    id: "5",
    titleMain: "El poder de liderar desde adentro",
    title: [
      { "text": "El poder", "style": { "color": "#0A2342", "fontWeight": "700", "fontSize": "2.2rem", "textShadow": "0 0 4px rgba(10, 35, 66, 0.5)", "WebkitTextStroke": "0.5px white" } },
      { "text": "de", "style": { "color": "#8B0000", "fontWeight": "900", "fontSize": "2.2rem" } },
      { "text": "liderar", "style": { "color": "#0A2342", "fontWeight": "700", "fontSize": "2.2rem", "WebkitTextStroke": "0.5px white" } },
      { "text": " desde adentro 🧠", "style": { "color": "#5F9EA0", "fontWeight": "800", "fontSize": "2.2rem", "textShadow": "0 0 4px rgba(0,0,0,0.3)" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Todo lo que necesitas para liderar ya vive en ti, solo hace falta reconectar y activarlo. ¡EL MOMENTO ES AHORA!",
    certifiedStudents: "Descubrirás que sí sabes y puedes ser un LIDER", //Te enseñaremos que si sabes y puedes liderar
    startDate: "Lunes 2 de marzo 2026",
    students: 142,
    imageIndex: liderazgointerno,
    image: liderazgo,
    ebook: null,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.8,
    reviews: 142,
    hook: [
      { "text": "Activa tu liderazgo profesional desde adentro", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "y conquista tus metas personales y profesionales🧠", "style": { "color": "rgb(45, 46, 80)", "fontWeight": "bold" } },
    ],
    hookMain: "El liderazgo no se improvisa: Se construye desde adentro. 🚀Empieza hoy",
    hookHeadband: "Este curso no es sólo una formación, es una reconexión con tu poder personal.",
    botonHookText: "¡Inscríbete y despierta al líder que eres! 🚀",
    SenseUrgency: "Esta oferta puede cambiar en cualquier momento",
    benefits: [
      "🎥 Clases pregrabadas y en vivo",
      "📘 Ebook práctico de apoyo totalmente GRATIS",
      "🎤 Masterclass en vivo",
      "📲 Acompañamiento directo por WhatsApp",
      "📜 CERTIFICADO de asistencia al finalizar el curso",
      "🎁 Descuento especial para próximos cursos en Dissemp Academy",
      "✔️ Activarás si o si el liderazgo que vive en ti",
    ],
    paintPoints: [
      "Sientes que, a pesar de tus esfuerzos, no logras influir positivamente en tu equipo o entorno.",
      "Te cuesta comunicar tus ideas con claridad y generar confianza en los demás.",
      "Has intentado mejorar tus habilidades de liderazgo por tu cuenta, pero te sientes estancado y sin guía.",
      "Te frustra ver cómo otros avanzan profesionalmente mientras tú sientes que tu potencial está dormido.",
      "Sabes que tienes cualidades de líder, pero no sabes cómo desarrollarlas o aplicarlas en tu vida diaria.",
    ],
    orientedTo: [
      "Eres profesional y buscas dar un siguiente paso en su carrera, pero sientes que algo te está frenando internamente",
      "Quieres pasar de ejecutar a inspirar y guiar equipos",
      "Estás en transición profesional y desean reinventarse como líderes",
      "Buscas un desarrollo personal profundo que les permita liderarse a sí mismos antes de liderar a otros",
      "Eres líder y buscas conectar mejor con tu equipo sin dejar de ser tú mismo",
      "Aún no eres líder y tienes inquietudes de crecimiento, pero no sabes por dónde empezar",
      "Estás listo para dejar de esperar una oportunidad, y comenzar a convertirte tú en la oportunidad"
    ],
    imgBonus: bonusliderazgo,
    bannerSuperior: bannerSuperiorLiderazgo,
    bannerInferior: bannerInferiorLiderazgo,
    includedCourse: [
      "Curso 100% online: Aprende desde cualquier lugar del mundo",
      "Acceso DE POR VIDA a todas las clases grabadas para que avances a tu ritmo",
      "Ebook teorico práctico descargable",
      "Sesión especial de bienvenida y cierre con el facilitador del curso",
      "Certificado de participacion digital al finalizar el curso",
      "Descuento especial para próximos cursos en Dissemp Academy"
    ],
    presale: false,
    modalOffer: false,
    emergencyStopwatch: false,
    faq: [
      {
        q: "¿Necesito experiencia previa para tomar el curso?",
        a: "No, en absoluto. El curso está diseñado específicamente para principiantes y te llevará desde los conceptos más básicos hasta temas avanzados. ¡Solo necesitas ganas de aprender!"
      },
      {
        q: "¿Qué tipo de soporte tendré durante el curso?",
        a: "Tendrás acceso a un grupo privado de estudiantes y al instructor para resolver dudas. Además, habrá sesiones de preguntas y respuestas en vivo para asegurar que nadie se quede atrás."
      },
      {
        q: "¿Puedo estudiar el curso a mi ritmo o hay horario de clases?",
        a: "El curso lo podrás estudiar en tus tiempos y a tu ritmo. Las clases son grabadas, aunque tendremos sesiones en vivo con el mentor, pero todas quedan en la plataforma de clases"
      },
    ],
    values: {
      co: {
        oldPrice: 155000,
        newPrice: 79900,
        currency: "COP",
        presale: [
          { fecha: '01/10', valor: '🔥 55.900' },
          { fecha: '07/10', valor: '😍 65.900' },
          { fecha: '15/10', valor: '😎 79.900' },
          { fecha: '20/10', valor: '🚀 95.900' }
        ]
      },
      ve: {
        oldPrice: 14900,
        newPrice: 9990,
        currency: "Bs",
        presale: [
          { fecha: '01/10', valor: '🔥 2.499' },
          { fecha: '07/10', valor: '😍 2.350' },
          { fecha: '15/10', valor: '😎 2.900' },
          { fecha: '20/10', valor: '🚀 3.500' },
        ]
      },
      cl: {
        oldPrice: 38450,
        newPrice: 13725,
        currency: "CLP",
        presale: [
          { fecha: '01/10', valor: '🔥 13.725' },
          { fecha: '07/10', valor: '😍 16.200' },
          { fecha: '15/10', valor: '😎 19.650' },
          { fecha: '20/10', valor: '🚀 23.500' },
        ]
      },
      mx: {
        oldPrice: 750,
        newPrice: 265,
        currency: "MXN",
        presale: [
          { fecha: '01/10', valor: '🔥 265' },
          { fecha: '07/10', valor: '😍 313' },
          { fecha: '15/10', valor: '😎 379' },
          { fecha: '20/10', valor: '🚀 455' },
        ]
      },
      pe: {
        oldPrice: 120,
        newPrice: 50,
        currency: "PEN",
        presale: [
          { fecha: '01/10', valor: '🔥 50' },
          { fecha: '07/10', valor: '😍 59' },
          { fecha: '15/10', valor: '😎 72' },
          { fecha: '20/10', valor: '🚀 87' },
        ]
      },
      us: {
        oldPrice: 87,
        newPrice: 46,
        currency: "$",
        presale: [
          { fecha: '01/10', valor: '🔥 39' },
          { fecha: '07/10', valor: '😍 46' },
          { fecha: '15/10', valor: '😎 57' },
          { fecha: '20/10', valor: '🚀 69' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 1: Reconociendo lo que ya tengo",
        content: "Descubre tu base sólida antes de liderar.",
        lessons: [
          { id: 1, title: "¿Quién soy realmente hoy?", youtubeId: "" },
          { id: 2, title: "Mi historia y lo que ya he superado", youtubeId: "" },
          { id: 3, title: "Reconexión con talentos y fortalezas naturales", youtubeId: "" },
          { id: 4, title: "¿Qué me mueve y me enciende profesionalmente?", youtubeId: "" },

        ],
      },
      {
        id: 2,
        title: "Módulo 2: Activando tu liderazgo interior",
        content: "Aquí no se enseña liderazgo. Se activa. No empieza afuera, empieza dentro.",
        lessons: [
          { id: 5, title: "¿Qué significa activar el liderazgo?", youtubeId: "" },
          { id: 6, title: "Rituales, desafíos y pequeñas decisiones que lo despiertan", youtubeId: "" },
          { id: 7, title: "¿Qué te impide activarlo hoy?", youtubeId: "" },
        ],
      },
      {
        id: 3,
        title: "Módulo 3: Descubriendo tu estilo de liderazgo",
        content: "Influye sin imitar: identifica tu forma de impactar.",
        lessons: [
          { id: 8, title: "Estilos naturales de liderazgo", youtubeId: "" },
          { id: 9, title: "El sello personal del líder auténtico", youtubeId: "" },
          { id: 10, title: "Tu propuesta de valor única", youtubeId: "" },
        ],
      },
      {
        id: 4,
        title: "Módulo 4: Liderarte para liderar ",
        content: "No puedes guiar a otros si no sabes guiarte a ti mismo.",
        lessons: [
          { id: 11, title: "Autoliderazgo en acción: hábitos, límites, decisiones conscientes", youtubeId: "" },
          { id: 12, title: "El diálogo interno y la coherencia entre lo que piensas, sientes y haces", youtubeId: "" },
          { id: 13, title: "Cómo sostenerte desde la autenticidad", youtubeId: "" },
        ],
      },
      {
        id: 5,
        title: "Módulo 5: Activando el coraje profesional ",
        content: "Del miedo a la acción real. Sin perfección, pero con poder.",
        lessons: [
          { id: 14, title: "Romper creencias limitantes sobre el liderazgo", youtubeId: "" },
          { id: 15, title: "La vulnerabilidad como herramienta de influencia", youtubeId: "" },
          { id: 16, title: "Cómo dar el primer paso (retos de microacción)", youtubeId: "" },
        ],
      },
      {
        id: 6,
        title: "Módulo 6: Tu hoja de ruta de liderazgo auténtico",
        content: "Un plan claro, original y tuyo. Sin copiar modelos ajenos.",
        lessons: [
          { id: 17, title: "Características de un líder auténtico", youtubeId: "" },
          { id: 18, title: "Cómo comunicar con claridad, conexión y confianza", youtubeId: "" },
          { id: 19, title: "Construir una hoja de ruta personal de liderazgo aplicado", youtubeId: "" },
        ],
      },
      {
        id: 7,
        title: "Módulo 7: Otros temas de Liderazgo",
        content: "Conceptualizaremos otros tipos de liderazgos",
        lessons: [
          { id: 20, title: "Ejemplos de líderes históricos y cotidianos", youtubeId: "" },
          { id: 21, title: "Un verdadero líder", youtubeId: "" },
          { id: 22, title: "Diferencias entre un jefe y un líder", youtubeId: "" },
          { id: 23, title: "Gestionar desde el liderazgo", youtubeId: "" },
          { id: 24, title: "Casos prácticos y análisis de liderazgo en acción", youtubeId: "" },
          { id: 25, title: "Es hora de poner en práctica los conocimientos", youtubeId: "" },
          { id: 26, title: "¿Qué es el liderazgo con IA?", youtubeId: "" },
        ],
      }
    ],
    instructor: {
      name: "Rimber José Yépez Alvarado",
      bio: "Apasionado por el desarrollo humano, me he enfocado gran parte de mi trayectoria reciente en temas de liderazgo, buscando siempre inspirar y activar el potencial de las personas desde adentro. Su enfoque combina la disciplina profesional con una visión humana y transformacional del trabajo.",
      image: prof1,
      profession: "LICENCIADO EN CONTADURIA PULICA"
    },
    configCheckout: {
      hook: "Descubre el poder de liderar desde adentro y transforma tu forma de influir en los demás",
      testimony1: "Este curso me ayudó a entender mi liderazgo desde una perspectiva mucho más consciente y humana. — Laura, 38 años",
      testimony2: "No solo aprendí a liderar equipos, también a liderarme a mí mismo. Fue una experiencia transformadora. — Andrés, 42 años",
      includedCourse: [
        "Curso 100% online: Aprende desde cualquier lugar del mundo",
        "Acceso DE POR VIDA a todas las clases grabadas para que avances a tu ritmo",
        "Ebook teórico-práctico descargable",
        "Sesión especial de bienvenida y cierre con el facilitador del curso",
        "Certificado de participación digital",
        "Descuento especial para próximos cursos en Dissemp Academy"
      ],
      bottomHook: "Este curso te ayudará a fortalecer tu liderazgo personal para impactar positivamente tu vida y tus relaciones.",
      topHook: "Curso diseñado para personas que desean desarrollar un liderazgo consciente, auténtico y desde adentro"
    },
    active: true,
    openRegistrations: true
  },
  {
    id: "6",
    image: paginasweb,
    students: 312,
    duration: "1 mes - 3h semanales",
    mode: "100% ONLINE. Las clases se publican martes y jueves",
    titleMain: "Desarrollo de páginas web [Programadores]",
    rating: 4.5,
    reviews: 21,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 265000,
        newPrice: 149900,
        currency: "COP",
      },
      ve: {
        oldPrice: 17800,//63,
        newPrice: 10200,//35.6,
        currency: "Bs"//"$",
      },
      cl: {
        oldPrice: 79000,
        newPrice: 48000,
        currency: "CLP",
      },
      mx: {
        oldPrice: 1400,
        newPrice: 795,
        currency: "MXN",
      },
      us: {
        oldPrice: 240,
        newPrice: 129.9,
        currency: "$",
      }
    },
    paymentMethods: {
      ve: "PAGO MÓVIL BANCARIO - BCV",
      co: "Tarjeta de crédito. Tarjeta de débito.  Transferencia Nequi y Bancolombia. Efecty",
      default: "Tarjeta de crédito. Tarjeta de débito. Transferencias bancarias directas"
    },
    active: false,
    openRegistrations: false
  },
  {
    id: "7",
    titleMain: "Diseño y desarrollo de páginas web con WordPress",
    image: paginaswebnoexpertos,
    title: [
      { "text": "Diseño y", "style": { /*"color": "#1e1e1e",*/ "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "desarrollo de páginas web", "style": { "color": "#004AAD", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "con", "style": { /*"color": "#1e1e1e",*/ "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "WordPress", "style": { "color": "#ff3b3b", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 5px rgba(255, 59, 59, 0.5)" } },
      { "text": "🔥💻", "style": { "color": "#333", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Sin experiencia previa y con acceso 100% online. Casi 156 alumnos ya estan diseñando su sitio web con éste curso",
    certifiedStudents: "No compres tu página web, desarrollala tu mismo",
    startDate: "3 de Noviembre del 2025",
    students: 156,
    imageIndex: index1,
    ebook: bonusebook,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.9,
    reviews: 588,
    hook: [
      { "text": "🌐Crea tu propia página web", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "con WordPress desde cero", "style": { "color": "#004AAD", "fontWeight": "bold" } },
      { "text": "aunque nunca hayas diseñado antes,", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "y empieza a ganar clientes en internet 🚀🔥", "style": { "color": "#FF3B3B", "fontWeight": "bold" } }
    ],
    emergencyStopwatch: false,
    // hookMain: "🎉Precio de cierre de inscripciones🚀ÚLTIMOS CUPOS 👇 ¿Vas a dejar pasar esta oferta?",
    hookMain: "🔥QUEDAN SÓLO HORAS CON ESTE DESCUENTO 🚀TE ENTREGAMOS UNA GARANTÍA, LEE TODO EL CONTENIDO",
    //hookHeadband: "MIENTRAS OTROS SIGUEN ESPERANDO EL 'MOMENTO PERFECTO', TÚ PUEDES ESTAR YA CONSTRUYENDO TU FUTURO COMO PROGRAMADOR",
    hookHeadband: "¿TE IMAGINAS DOMINAR LAS BASES DE LA PROGRAMACIÓN EN 4 SEMANAS? ¡TÚ TAMBIÉN PUEDES!",
    botonHookText: "¡Quiero Transformar mi Futuro! 👨‍💻",
    SenseUrgency: "¡CUPOS LIMITADOS!",
    orientedTo: [
      "Estás iniciando en carreras como informática, sistemas o computación",
      "Te gusta la tecnología y quieres aprender programación con JavaScript desde cero",
      "¿Eres emprendedor y quieres crear software para ganar más dinero?",
      "Sueñas con trabajar remoto a futuro creando apps, páginas web o videojuegos",
      "Tienes nociones básicas y quieres reforzar tus fundamentos en programación"
    ],
    imgBonus: bonusprogramacion,
    benefits: [
      "🎥 Clases grabadas + sesiones en vivo para resolver tus dudas",
      "🎯 Ejercicios prácticos desde la primera clase",
      "💻 Clases dinámicas e interactivas",
      "📜 CERTIFICADO de asistencia al finalizar",
      "🎁 E-book “Programación para Todos;” de obsequio",
      "🧠 Aprende a programar y a futuro elige tu lenguaje favorito",
      "✔️ Curso orientado a JAVASCRIPT",
    ],
    includedCourse: [
      "Curso 100% online para que puedas ver las clases desde cualquier lugar del mundo",
      "Acceso DE POR VIDA a la plataforma donde podrás ver las clases pregrabadas a tu ritmo",
      "Oportunidad para resolver dudas y ejercicios con clases en vivo",
      "Ebook práctico 'Programación para Todos;' TOTALMENTE GRATIS",
      "Certificado de asistencia al finalizar el curso",
      "Conocimiento sumamente valioso para iniciarte en el mundo de la programación con JAVASCRIPT",
    ],
    presale: true,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 246000,
        newPrice: 114900, //128900
        currency: "COP",
        presale: [
          { fecha: '16/09', valor: '🔥 100.900' },
          { fecha: '22/09', valor: '😍 114.900' },
          { fecha: '30/09', valor: '🙂 128.900' },
          { fecha: '08/10', valor: '🔷 141.900' },
        ]
      },
      ve: {
        oldPrice: 19900, // 59.9,
        newPrice: 14500, //24.9,
        currency: "Bs",
        presale: [
          { fecha: '16/09', valor: '🔥 3.899' },
          { fecha: '22/09', valor: '😍 4.199' },
          { fecha: '30/09', valor: '🙂 4.499' },
          { fecha: '08/10', valor: '🔷 4.750' },
        ]
      },
      cl: {
        oldPrice: 58500,
        newPrice: 32900,
        currency: "CLP",
        presale: [
          { fecha: '16/09', valor: '🔥 28.900' },
          { fecha: '22/09', valor: '😍 32.900' },
          { fecha: '30/09', valor: '🙂 38.200' },
          { fecha: '08/10', valor: '🔷 42.490' },
        ]
      },
      mx: {
        oldPrice: 915,
        newPrice: 735,
        currency: "MXN",
        presale: [
          { fecha: '16/09', valor: '🔥 659' },
          { fecha: '22/09', valor: '😍 735' },
          { fecha: '30/09', valor: '🙂 850' },
          { fecha: '08/10', valor: '🔷 999' },
        ]
      },
      pe: {
        oldPrice: 189,
        newPrice: 99,
        currency: "PEN",
        presale: [
          { fecha: '16/09', valor: '🔥 89' },
          { fecha: '22/09', valor: '😍 99' },
          { fecha: '30/09', valor: '🙂 112' },
          { fecha: '08/10', valor: '🔷 124' },
        ]
      },
      us: {
        oldPrice: 147,
        newPrice: 63,
        currency: "$",
        presale: [
          { fecha: '16/09', valor: '🔥 49' },
          { fecha: '22/09', valor: '😍 63' },
          { fecha: '30/09', valor: '🙂 99' },
          { fecha: '08/10', valor: '🔷 120' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 0: Bienvenida al curso",
        content: "Bienvenida, conoce qué estudiaremos, recursos, a donde debemos apuntar, reglas y recomendaciones",
        lessons: [
          { id: 1, title: "Hablemos de tecnología", youtubeId: "-gKqvCk3x7E" },
          { id: 2, title: "Ventajas de trabajar en tecnología", youtubeId: "b4gWiBNKSzs" },
          { id: 3, title: "¿Cómo estudiaremos en este curso?", youtubeId: "VVRma_Dcuoo" },
          { id: 4, title: "Beneficios del curso", youtubeId: "0BN37SAYF68" },
          { id: 5, title: "Contenido de estudio", youtubeId: "vONB02Kj1go" },
          { id: 6, title: "¿A donde debemos apuntar?", youtubeId: "D5fM37LqNhY" },
          { id: 7, title: "Reglas y recomendaciones", youtubeId: "vojYRkmuQ5w" },
        ],
      },
      {
        id: 2,
        title: "Módulo 1: Fundamentos de la Programación",
        content: "Aprendamos con prácticas los conceptos básicos de la programación, pensamiento lógico, algoritmos y pensamiento algoritmico.",
        lessons: [
          { id: 8, title: "Conceptos básicos de la programación", youtubeId: "ksHKDzSx0Qk" },
        ],
      },
      {
        id: 3,
        title: "Módulo 2: Variables, Tipos de Datos y Operadores",
        content: "Cómo definir variables, como entenderlas más fácil, cuales tipos de datos hay, como pueden compararse.",
        lessons: [
          { id: 9, title: "Repaso clase pasada", youtubeId: "6NcWtyXa3A0" },
          { id: 10, title: "Entendamos que son variables", youtubeId: "_dqbVGto-4E" },
          { id: 11, title: "Tipos de datos", youtubeId: "Hw76rtGJVTo" },
          { id: 12, title: "Operadores lógicos", youtubeId: "03op78Fk3NA" },
        ],
      },
      {
        id: 4,
        title: "Módulo 3: Flujos de Control",
        content: "Cómo iterar en un conjunto de datos con ciclos y bucles.",
        lessons: [
          { id: 13, title: "Repaso clase pasada", youtubeId: "k4CmL3tWWcQ" },
          { id: 14, title: "Estructuras de control de flujo", youtubeId: "2agBD5oDGN0" },
          { id: 15, title: "Estructura if / if-else", youtubeId: "TBNsjhuGOAA" },
          { id: 16, title: "Ciclo Mientras", youtubeId: "2Rx_t6FCBtk" },
          { id: 17, title: "Ciclo Hacer-Mientras", youtubeId: "1MFAokd9M8I" },
          { id: 18, title: "Ciclo Para", youtubeId: "KQWRto4Sq9k" },
        ],
      },
      {
        id: 5,
        title: "Módulo 4: Estructuras de Datos y Arrays",
        content: "Como entender a la perfección los arreglos, como se usan, y buenas prácticas con estructuras de datos.",
        lessons: [
          { id: 19, title: "Llamado de atención del curso", youtubeId: "8A2netOvTT8" },
          { id: 20, title: "Ejercicios clase pasada", youtubeId: "nRlnoOmv1x8" },
          { id: 21, title: "Estructuras de datos", youtubeId: "dSJ7930lDpA" },
          { id: 22, title: "Manipulación de datos con arrays", youtubeId: "VmWadLAjlMs" },
        ],
      },
      {
        id: 6,
        title: "Módulo 5: Funciones y Código Limpio",
        content: "Como optimizar mi código con funciones, reutilización de código y principios de código limpio en javascript.",
        lessons: [
          { id: 23, title: "Repaso clase pasada", youtubeId: "P8gB9dxC0uM" },
          { id: 24, title: "¿Qué es código limpio? Características", youtubeId: "4OngQbN6p7k" },
          { id: 25, title: "Principios del código limpio", youtubeId: "g7HA_-LROFc" },
          { id: 26, title: "Funciones", youtubeId: "wfAcULLIX00" },
          { id: 27, title: "Manejo de funciones en JavaScript", youtubeId: "L-75e-cTLuM" },
        ],
      },
      {
        id: 7,
        title: "Módulo 6: Programación Orientada a Objetos (POO)",
        content: "Para qué sirve la POO, como me ayuda a la hora de programar, como estructuro mis proyectos. Aplicación práctica.",
        lessons: [
          { id: 28, title: "Repaso clase pasada", youtubeId: "lcrB2ZnSdUs" },
          { id: 29, title: "¿Qué es la POO?", youtubeId: "kcqkzmrPd6o" },
          { id: 30, title: "Objetos y clases", youtubeId: "q2rw84SKM4Y" },
          { id: 31, title: "Propiedades y métodos", youtubeId: "giyaYpejw2c" },
          { id: 32, title: "Ejemplos en javascript", youtubeId: "5PrZaMOxTRA" },
          { id: 33, title: "Constructores", youtubeId: "Kcawk6mqjHY" },
          { id: 34, title: "Herencia", youtubeId: "JuCw-AYnS2U" },
          { id: 35, title: "Polimorfismo", youtubeId: "QsiikljBDRg" },
          { id: 36, title: "Prácticas de POO", youtubeId: "YuLzQTIqXXE" },
        ],
      },
      {
        id: 8,
        title: "Módulo 7: BONUS TRACK (Regalo)",
        content: "Como resolver cualquier duda de programación con IA, como programar con IA, como hacer sitios web con IA",
        lessons: [
          { id: 31, title: "¿Qué es la IA?", youtubeId: "rhA1w_5qkBs" },
          { id: 32, title: "¿Qué es ChatGPT?", youtubeId: "quaGdPSkOfQ" },
          { id: 33, title: "¿Cómo usar la IA para programar?", youtubeId: "bfFHx8yy1J8" },
        ],
      },
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Ingeniero en informática con más de 8 años de experiencia como desarrollador full stack y profesor del área de software de diferentes áreas. Dinámico, proactivo y dispuesto a entregar todo su conocimiento a la comunidad...",
      image: prof0,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "Descubre el poder de liderar desde adentro y transforma tu forma de influir en los demás",
      testimony1: "Este curso me ayudó a entender mi liderazgo desde una perspectiva mucho más consciente y humana. — Laura, 38 años",
      testimony2: "No solo aprendí a liderar equipos, también a liderarme a mí mismo. Fue una experiencia transformadora. — Andrés, 42 años",
      includedCourse: [
        "Curso 100% online: Aprende desde cualquier lugar del mundo",
        "Acceso DE POR VIDA a todas las clases grabadas para que avances a tu ritmo",
        "Ebook teórico-práctico descargable",
        "Sesión especial de bienvenida y cierre con el facilitador del curso",
        "Certificado de participación digital",
        "Descuento especial para próximos cursos en Dissemp Academy"
      ],
      bottomHook: "Este curso te ayudará a fortalecer tu liderazgo personal para impactar positivamente tu vida y tus relaciones.",
      topHook: "Curso diseñado para personas que desean desarrollar un liderazgo consciente, auténtico y desde adentro"
    },
    active: false,
    openRegistrations: false
  },
  {
    id: "8",
    image: resinEpoxica,
    students: 95,
    duration: "1 mes - 4h semanales",
    mode: "100% ONLINE. Las clases se publican martes y jueves",
    titleMain: "Aumenta tus ingresos. Trabaja con Resina Epóxica",
    rating: 4.4,
    reviews: 18,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 95000,
        newPrice: 86000,
        currency: "COP",
      },
      ve: {
        oldPrice: 14320, //22,
        newPrice: 7890, //20.5,
        currency: "Bs", //"$",
      },
      cl: {
        oldPrice: 55000,
        newPrice: 38000,
        currency: "CLP",
      },
      mx: {
        oldPrice: 471,
        newPrice: 430,
        currency: "MXN",
      },
      us: {
        oldPrice: 59,
        newPrice: 39,
        currency: "$",
      }
    },
    paymentMethods: {
      ve: "PAGO MÓVIL BANCARIO - BCV",
      co: "Tarjeta de crédito. Tarjeta de débito.  Transferencia Nequi y Bancolombia. Efecty",
      default: "Tarjeta de crédito. Tarjeta de débito. Transferencias bancarias directas"
    },
    active: false,
    openRegistrations: false
  },
  {
    id: "9",
    image: prodLocucion,
    students: 545,
    duration: "1 mes - 3h semanales",
    mode: "100% ONLINE. Las clases se publican martes y jueves",
    titleMain: "Grandes discursos: Oratoria y miedo escénico",
    rating: 4.4,
    reviews: 20,
    oldPrice: "154.800 COP",
    newPrice: "107.000 COP",
    modalOffer: false,
    values: {
      co: {
        oldPrice: 154000,
        newPrice: 107000,
        currency: "COP",
      },
      ve: {
        oldPrice: 4200, //37,
        newPrice: 3650, //25.9,
        currency: "Bs" //"$",
      },
      cl: {
        oldPrice: 79000,
        newPrice: 48000,
        currency: "CLP",
      },
      mx: {
        oldPrice: 1400,
        newPrice: 795,
        currency: "MXN",
      },
      us: {
        oldPrice: 110,
        newPrice: 89.5,
        currency: "$",
      }
    },
    paymentMethods: {
      ve: "PAGO MÓVIL BANCARIO - BCV",
      co: "Tarjeta de crédito. Tarjeta de débito. PSE. Transferencia Nequi y Bancolombia. Efecty",
      default: "Tarjeta de crédito. Tarjeta de débito. Transferencias bancarias directas"
    },
    active: false,
    openRegistrations: false
  },
  {
    id: "10",
    titleMain: "Aumenta tus ventas creando anuncios con Inteligencia Artificial",
    title: [
      { "text": "Aumenta tus", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "ventas", "style": { "color": "#00c853", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "creando", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "anuncios con IA", "style": { "color": "#6a00ff", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 6px rgba(106,0,255,0.5)" } },
      { "text": "🤖📈", "style": { "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Workshop Online",
    type: "Taller",
    subtitle: "Taller intensivo online de 2 días donde aprenderás a crear imágenes y videos con IA para vender productos o servicios, incluso si hoy no sabes nada de inteligencia artificial.",
    certifiedStudents: "Taller práctico paso a paso + grabaciones incluidas",
    startDate: "Sábado 28 de febrero",
    students: 89,
    imageIndex: "",
    image: talleria,
    ebook: "",
    duration: "2 días",
    mode: "100% ONLINE. Taller en vivo con acceso posterior a la grabación para que puedas repasar el contenido",
    rating: 4.7,
    reviews: 89,
    hook: [
      { "text": "El problema no es tu producto o servicio,", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "es cómo lo estás mostrando. ", "style": { "color": "red", "fontWeight": "bold" } },
      { "text": "Aprende a crear imágenes y videos", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "con IA que hacen que tus publicaciones vendan", "style": { "color": "#004AAD", "fontWeight": "bold" } },
    ],
    // hookMain: "⏳ HOY en la tarde inicia nuestro workshop en vivo - Estamos cerrando inscripciones",
    hookMain: "CUPOS LLENOS. Inscripciones cerradas 🔒",
    hookHeadband: "TALLER PRÁCTICO + CUPO LIMITADO · APRENDE HOY LO QUE OTROS APRENDERÁN EN AÑOS",
    botonHookText: "¡Quiero mi cupo ahora!",
    SenseUrgency: "¡El momento es ahora!",
    orientedTo: [
      "Emprendedores que quieren vender más usando anuncios digitales",
      "Personas que quieren crear imágenes y videos con IA sin ser diseñadores",
      "Marketers, community managers y dueños de negocios",
      "Personas que hacen anuncios pero no obtienen resultados",
      "Cualquier persona que quiera aprender IA aplicada a ventas reales"
    ],
    paintPoints: [
      "Sientes que tus publicaciones de ventas no llaman la atención ni generan compras.",
      "No sabes qué imágenes o videos usar para vender tus productos o servicios.",
      "Crees que la IA es muy compleja o solo para expertos.",
      "Eres de los que publica 50 imagenes de tus productos y no convierten.",
      "Quieres innovar tu negocio para aumentar ventas."
    ],
    imgBonus: bonustalleria,
    bannerSuperior: bannerSuperiorContentIA,
    bannerInferior: bannerInferiorContentIA,
    vslLink: "FZ0GYmIlNGs",
    benefits: [
      "🤖 Aprende a usar IA para crear imágenes y videos de alto impacto",
      "🎯 Taller Online 100% práctico enfocado en creación de contenido",
      "📘 Guía paso a paso totalmente GRATIS",
      "🧠 Lista de prompts y métodos listos para usar",
      "💼 Ideal para productos, servicios y marcas personales",
      "📲 Comunidad de estudiantes vía whatsApp"
    ],
    includedCourse: [
      "Workshop online en vivo de 2 días",
      "Herramientas de creación de imágenes publicitarias con IA",
      "Herramientas de creación de videos publicitarios con IA",
      "Prompts optimizados para vender",
      "Ejercicios prácticos",
      "Guía paso a paso de apoyo"
    ],
    faq: [
      {
        q: "¿Necesito conocimientos previos en diseño o inteligencia artificial?",
        a: "No. El taller está diseñado para principiantes y emprendedores. Aprenderás paso a paso desde cero."
      },
      {
        q: "¿Las herramientas son gratuitas?",
        a: "Vemos opciones gratuitas y de pago. Te enseñaré cuáles valen la pena para empezar sin gastar dinero y cuáles usar cuando quieras escalar."
      },
      {
        q: "¿Esto sirve para cualquier tipo de negocio?",
        a: "Sí. Los métodos enseñados aplican para productos físicos, servicios, cursos y marcas personales."
      }
    ],
    emergencyStopwatch: false,
    presale: false,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 105000, newPrice: 76000, currency: "COP", presale: [
          { fecha: '01/02', valor: '🔥 24.900' },
          { fecha: '09/02', valor: '😍 32.500' },
          { fecha: '18/02', valor: '🙂 38.200' },
          { fecha: '27/02', valor: '🔷 49.900' },
        ]
      },
      ve: {
        oldPrice: 19200, newPrice: 12799, currency: "Bs", presale: [
          { fecha: '01/02', valor: '🔥 2.799' },
          { fecha: '09/02', valor: '😍 3.500' },
          { fecha: '18/02', valor: '🙂 4.399' },
          { fecha: '27/02', valor: '🔷 5.400' },
        ]
      },
      cl: {
        oldPrice: 32100, newPrice: 18169, currency: "CLP", presale: [
          { fecha: '01/02', valor: '🔥 6.025' },
          { fecha: '09/02', valor: '😍 7.750' },
          { fecha: '18/02', valor: '🙂 9.050' },
          { fecha: '27/02', valor: '🔷 11.650' },
        ]
      },
      mx: {
        oldPrice: 420, newPrice: 355, currency: "MXN", presale: [
          { fecha: '01/02', valor: '🔥 121' },
          { fecha: '09/02', valor: '😍 155' },
          { fecha: '18/02', valor: '🙂 182' },
          { fecha: '27/02', valor: '🔷 234' },
        ]
      },
      pe: {
        oldPrice: 96, newPrice: 68, currency: "PEN", presale: [
          { fecha: '01/02', valor: '🔥 24' },
          { fecha: '09/02', valor: '😍 30' },
          { fecha: '18/02', valor: '🙂 35' },
          { fecha: '27/02', valor: '🔷 46' },
        ]
      },
      us: {
        oldPrice: 92, newPrice: 49, currency: "$", presale: [
          { fecha: '01/02', valor: '🔥 12' },
          { fecha: '09/02', valor: '😍 16' },
          { fecha: '18/02', valor: '🙂 23' },
          { fecha: '27/02', valor: '🔷 30' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Día 1: Fundamentos y creación de imágenes con IA",
        content: "Introducción práctica a la IA aplicada a marketing y creación de imágenes que venden.",
        lessons: [
          { id: 1, title: "Cómo la IA está revolucionando las ventas", youtubeId: "" },
          { id: 2, title: "Errores comunes en anuncios digitales", youtubeId: "" },
          { id: 3, title: "Creación de imágenes publicitarias con IA", youtubeId: "" },
          { id: 4, title: "Prompts que convierten", youtubeId: "" }
        ]
      },
      {
        id: 2,
        title: "Día 2: Videos con IA y estrategia de ventas",
        content: "Creación de videos con IA y cómo usarlos estratégicamente para vender.",
        lessons: [
          { id: 5, title: "Creación de videos publicitarios con IA", youtubeId: "" },
          { id: 6, title: "Anuncios que llaman la atención y venden", youtubeId: "" },
          { id: 7, title: "Estrategias óptimas para generar videos que venden", youtubeId: "" }
        ]
      }
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Ingeniero en informática y marketer digital con experiencia en automatización, programación y uso de IA aplicada a ventas reales.",
      image: prof0,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "Aprende las herramientas más potentes",
      testimony1: "La IA esta en avance, lo que antes me tardaba días, ahora lo hago en horas. — José G., 38 años",
      testimony2: "Es increible todo lo que aprendí en este taller, y sigo practicando día a día. — Andreina, 28 años",
      includedCourse: [
        "Acceso completo a los 2 días del workshop online",
        "Guía paso a paso del contenido totalmente GRATIS",
        "Herramientas y maneras de crear videos e imágenes con IA",
        "Promps predefinidos para crear anuncios en automático",
        "Garantía de satisfacción incluida",
      ],
      bottomHook: "Con este workshop aprenderás a usar la IA para aumentar tus ventas.",
      topHook: "No necesitas ser un experto en tecnología ni informática"
    },
    active: true,
    openRegistrations: false
  },
  {
    id: "11",
    titleMain: "Viaja a Europa sin agencias de viaje",
    title: [
      { "text": "Viaja por el mundo", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "gastando menos", "style": { "color": "#00c853", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "sin depender de", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "agencias de viaje", "style": { "color": "#6a00ff", "fontWeight": "bold", "fontSize": "2rem", "textShadow": "0 0 6px rgba(106,0,255,0.5)" } },
      { "text": "✈️🌍", "style": { "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Aprende paso a paso cómo organizar tu propio viaje internacional sin agencias, ahorrando hasta un 40% del costo total. Destinos, visas, vuelos, hoteles y mucho más, todo en un solo lugar.",
    certifiedStudents: "Curso práctico con plantillas, guías y kit físico de viajero incluido",
    startDate: "",
    students: 0,
    imageIndex: "",
    image: index4,
    ebook: "",
    duration: "Acceso inmediato y de por vida",
    mode: "100% ONLINE. Aprende a tu ritmo con acceso permanente al contenido",
    rating: 0,
    reviews: 0,
    hook: [
      { "text": "Un Eurotour que las agencias cobran a ", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "$3.000 USD ", "style": { "color": "red", "fontWeight": "bold" } },
      { "text": "puede costarte solo ", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "$1.800 USD si aprendes a organizarlo tú mismo.", "style": { "color": "#004AAD", "fontWeight": "bold" } }
    ],
    hookMain: "🌍 ¡El mundo te está esperando — empieza a planear tu primer viaje hoy!",
    hookHeadband: "CURSO PRÁCTICO + PLANTILLAS INCLUIDAS · VIAJA MÁS BARATO QUE CON CUALQUIER AGENCIA",
    botonHookText: "¡Quiero aprender a viajar solo!",
    SenseUrgency: "¡Tu próximo viaje empieza aquí!",
    orientedTo: [
      "Personas que sueñan con viajar al extranjero pero creen que es muy costoso",
      "Viajeros que quieren dejar de depender de agencias de viaje",
      "Jóvenes y adultos que quieren hacer su primer viaje internacional solos",
      "Personas que quieren optimizar su presupuesto y viajar más por menos dinero",
      "Cualquiera que quiera tener el control total de su experiencia de viaje"
    ],
    paintPoints: [
      "Sientes que viajar al extranjero es solo para personas con mucho dinero.",
      "No sabes cómo comprar vuelos baratos, conseguir visa o contratar un seguro de viaje.",
      "Las agencias te cobran demasiado y no tienes la libertad de personalizar tu viaje.",
      "Te da miedo viajar solo porque no sabes cómo organizarte.",
      "Has intentado planear un viaje pero terminas confundido con tanto proceso."
    ],
    imgBonus: "",
    bannerSuperior: "",
    bannerInferior: "",
    vslLink: "",
    benefits: [
      "✈️ Aprende a comprar vuelos internacionales al mejor precio",
      "🏨 Encuentra hoteles y estadías de calidad sin pagar de más",
      "🛂 Guía completa para tramitar visas según tu destino",
      "📱 Configura tu línea celular para usarla en cualquier país",
      "🛡️ Entiende y contrata el seguro de viaje ideal para ti",
      "🗺️ Plantillas listas para armar tu itinerario de viaje",
      "💰 Estrategias de ahorro y administración del presupuesto viajero",
      "🎒 Kit físico del viajero: bolso, libreta, gorra y medias del curso"
    ],
    includedCourse: [
      "Acceso completo al curso online de por vida",
      "Módulo de compra de boletos aéreos internacionales",
      "Módulo de trámite de visas internacionales",
      "Módulo de seguro de viaje y línea celular internacional",
      "Módulo de hoteles, atracciones y administración del presupuesto",
      "Plantillas editables para armar tu itinerario de viaje",
      "Kit físico del viajero: bolso + libreta + gorra + medias del curso",
      "Actualizaciones del contenido sin costo adicional"
    ],
    faq: [
      {
        q: "¿Necesito experiencia viajando para tomar este curso?",
        a: "No. El curso está diseñado desde cero para personas que nunca han viajado solas al exterior. Explicamos cada proceso de forma sencilla y paso a paso."
      },
      {
        q: "¿El curso sirve para viajar a cualquier país del mundo?",
        a: "Sí. Enseñamos metodologías y herramientas que aplican para cualquier destino internacional, incluyendo Europa, Estados Unidos, Latinoamérica y Asia."
      },
      {
        q: "¿Cuándo recibo el kit físico del viajero?",
        a: "El kit físico se envía a tu dirección una vez realizado el pago. Los tiempos de entrega varían según tu país de residencia."
      },
      {
        q: "¿Cada cuánto se compran los pasajes dentro del curso?",
        a: "El curso incluye sesiones prácticas de búsqueda y compra de pasajes en fechas programadas para que puedas aplicar lo aprendido en tiempo real con acompañamiento."
      },
      {
        q: "¿Las plantillas de itinerario son editables?",
        a: "Sí. Recibirás plantillas en formato editable para que puedas personalizarlas con tu propio destino, fechas, actividades y presupuesto."
      }
    ],
    emergencyStopwatch: false,
    presale: false,
    modalOffer: false,
    values: {
      co: { oldPrice: 1599000, newPrice: 1199000, currency: "COP", presale: [] },
      ve: { oldPrice: 250000, newPrice: 189900, currency: "Bs", presale: [] },
      cl: { oldPrice: 320000, newPrice: 279000, currency: "CLP", presale: [] },
      mx: { oldPrice: 6500, newPrice: 5499, currency: "MXN", presale: [] },
      pe: { oldPrice: 1350, newPrice: 1149, currency: "PEN", presale: [] },
      us: { oldPrice: 359, newPrice: 299, currency: "$", presale: [] }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 1: Mentalidad y planificación del viajero independiente",
        content: "Bases para pensar como un viajero inteligente: cómo ahorrar, presupuestar y planificar desde cero.",
        lessons: [
          { id: 1, title: "Por qué viajar sin agencia es más económico y libre", youtubeId: "" },
          { id: 2, title: "Cómo definir tu destino y calcular tu presupuesto real", youtubeId: "" },
          { id: 3, title: "Estrategias de ahorro para financiar tu viaje", youtubeId: "" },
          { id: 4, title: "Administración del dinero antes y durante el viaje", youtubeId: "" }
        ]
      },
      {
        id: 2,
        title: "Módulo 2: Vuelos internacionales — Cómo comprar barato",
        content: "Todo lo que necesitas saber para encontrar y comprar los mejores vuelos al precio más bajo.",
        lessons: [
          { id: 5, title: "Las mejores plataformas para buscar vuelos baratos", youtubeId: "" },
          { id: 6, title: "Cuándo y cómo comprar para pagar menos", youtubeId: "" },
          { id: 7, title: "Vuelos de conexión vs. directos: cómo sacarles provecho", youtubeId: "" },
          { id: 8, title: "Práctica en vivo: compramos un pasaje juntos", youtubeId: "" }
        ]
      },
      {
        id: 3,
        title: "Módulo 3: Visas — Sin misterios ni intermediarios",
        content: "Aprende a tramitar tu visa de forma independiente según tu destino y nacionalidad.",
        lessons: [
          { id: 9, title: "Tipos de visa y cómo saber cuál necesitas", youtubeId: "" },
          { id: 10, title: "Documentación necesaria y cómo prepararla", youtubeId: "" },
          { id: 11, title: "Proceso de solicitud paso a paso: Europa, USA y más", youtubeId: "" },
          { id: 12, title: "Errores comunes que rechazan una visa y cómo evitarlos", youtubeId: "" }
        ]
      },
      {
        id: 4,
        title: "Módulo 4: Hoteles, alojamiento y atracciones",
        content: "Cómo encontrar dónde quedarte bien ubicado y económico, y cómo organizar tus actividades.",
        lessons: [
          { id: 13, title: "Plataformas de alojamiento: hoteles, hostales y apartamentos", youtubeId: "" },
          { id: 14, title: "Cómo leer reseñas y elegir el alojamiento correcto", youtubeId: "" },
          { id: 15, title: "Compra de atracciones y tours sin intermediarios", youtubeId: "" },
          { id: 16, title: "Cómo armar tu itinerario diario optimizando tiempo y dinero", youtubeId: "" }
        ]
      },
      {
        id: 5,
        title: "Módulo 5: Línea celular y seguro de viaje internacional",
        content: "Conéctate y protégete en cualquier parte del mundo sin pagar de más.",
        lessons: [
          { id: 17, title: "Opciones de línea celular internacional: SIM, eSIM y roaming", youtubeId: "" },
          { id: 18, title: "Cuál elegir según tu destino y cuánto cuesta realmente", youtubeId: "" },
          { id: 19, title: "Qué es el seguro de viaje y por qué es obligatorio", youtubeId: "" },
          { id: 20, title: "Cómo comparar y contratar el mejor seguro para tu viaje", youtubeId: "" }
        ]
      },
      {
        id: 6,
        title: "Módulo 6: Tu itinerario completo — De principio a fin",
        content: "Aprende a usar las plantillas del curso para armar un itinerario profesional y sin estrés.",
        lessons: [
          { id: 21, title: "Cómo usar las plantillas de itinerario del curso", youtubeId: "" },
          { id: 22, title: "Caso práctico: armamos un Eurotour completo paso a paso", youtubeId: "" },
          { id: 23, title: "Tips de viajero experimentado: qué llevar, qué evitar", youtubeId: "" },
          { id: 24, title: "Checklist final antes de subir al avión", youtubeId: "" }
        ]
      }
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Ingeniero en informática, estratega digital y viajero independiente. Ha organizado viajes internacionales sin agencias optimizando costos y maximizando experiencias. Ahora comparte ese conocimiento para que tú también puedas hacerlo.",
      image: "",
      profession: "INGENIERO EN INFORMÁTICA & VIAJERO INDEPENDIENTE"
    },
    configCheckout: {
      hook: "Aprende a viajar por el mundo pagando mucho menos",
      testimony1: "Armé mi primer viaje a Europa solo con este curso y ahorré más de $900 USD. — Camila R., 27 años",
      testimony2: "Nunca pensé que tramitar una visa podía ser tan sencillo. Todo explicado paso a paso. — Andrés M., 34 años",
      includedCourse: [
        "Acceso completo al curso online de por vida",
        "Plantillas editables de itinerario de viaje",
        "Kit físico: bolso + libreta + gorra + medias del curso",
        "Módulos de vuelos, visas, hoteles, seguro y línea celular",
        "Garantía de satisfacción incluida"
      ],
      bottomHook: "Con este curso aprenderás a organizar tu viaje internacional de forma independiente, segura y económica.",
      topHook: "No necesitas ser experto ni tener mucho dinero para viajar al exterior"
    },
    active: true,
    openRegistrations: true
  },
  {
    id: "12",
    titleMain: "Código de Cierre — Curso para convertir conversaciones de WhatsApp en ventas reales",
    title: [
      { "text": "Aumenta tu", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "cierre de ventas", "style": { "color": "#25D366", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "por WhatsApp", "style": { "fontWeight": "normal", "fontSize": "2rem" } },
      { "text": "con estrategia", "style": { "color": "#004AAD", "fontWeight": "bold", "fontSize": "2rem" } },
      { "text": "💬🔥", "style": { "color": "#333", "fontWeight": "normal", "fontSize": "2rem" } }
    ],
    typeTitle: "Curso Online",
    type: "Curso",
    subtitle: "Aprende qué decir cuando te preguntan el precio, cuando te dicen “lo voy a pensar”, cuando dejan de responder y cuando tienes que hacer seguimiento sin parecer desesperado",
    certifiedStudents: "Para emprendedores, vendedores, dueños de negocios y freelancers que venden por WhatsApp",
    startDate: "Sábado 10 de octubre",
    students: 132,
    imageIndex: index3,
    image: index3,
    ebook: null,
    duration: "A tu ritmo",
    mode: "100% ONLINE. Todas las clases son pregrabadas y quedan disponibles para ser vistas en cualquier momento, a tu ritmo",
    rating: 4.8,
    reviews: 132,
    hook: [
      { "text": "De 'hola, ¿cuánto cuesta?' a", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "'listo, ¿cómo pago?' 💬", "style": { "color": "#25D366", "fontWeight": "bold" } },
      { "text": "Domina el cierre de ventas", "style": { "color": "black", "fontWeight": "normal" } },
      { "text": "por WhatsApp con método real", "style": { "color": "#004AAD", "fontWeight": "bold" } },
    ],
//    hookMain: "⚡ Precio de preventa disponible por pocos días",
    hookMain: "🔥 PRECIO DE PREVENTA ACTIVA AHORA",
    hookHeadband: "APRENDE A CONVERTIR CONVERSACIONES EN VENTAS — SIN BAJAR EL PRECIO NI SONAR DESESPERADO",
    botonHookText: "¡Quiero aprender ahora!",
    SenseUrgency: "PRECIO DE PREVENTA ACTIVO AHORA",
    vslLink: null,
    orientedTo: [
      "Eres emprendedor y vendes tus productos o servicios por WhatsApp",
      "Eres vendedor y quieres mejorar tu tasa de cierre con técnicas reales",
      "Eres freelancer y pierdes clientes porque no sabes cómo manejar objeciones",
      "Tienes un negocio local y quieres convertir más chats en ventas",
      "Ya vendes por WhatsApp pero sientes que puedes cerrar muchos más negocios"
    ],
    paintPoints: [
      "El cliente pregunta el precio y desaparece sin responder nada más.",
      "'Lo voy a pensar' o 'está caro' te dejan sin saber qué responder.",
      "Envías el catálogo completo y el cliente simplemente te deja en visto.",
      "Terminas bajando el precio porque no sabes cómo defender el valor de lo que vendes.",
      "Inviertes horas respondiendo chats y al final cierras muy pocas ventas.",
    ],
    imgBonus: null,
    bannerSuperior: null,
    bannerInferior: null,
    benefits: [
     // "📖 Manual \"Del primer mensaje al cierre\" — la guía completa de la conversación, paso a paso",
      "🎯 30 scripts de cierre listos para copiar y pegar en las 6 objeciones más comunes",
      "🔁 Plantilla de secuencia de reactivación para clientes fríos o en visto",
      "📊 Plantilla de seguimiento (mini-CRM) para no perder el hilo de ningún cliente",
      "🧠 Cheat sheet visual con los 4 perfiles de cliente y cómo hablarle a cada uno",
      "💻 Clases cortas de 7–10 min diseñadas para estudiar sin aburrirte",
      "👥 Grupo de soporte por WhatsApp para resolver tus dudas",
    ],
    includedCourse: [
      "Curso 100% online con clases pregrabadas para ver a tu ritmo",
      "9 Módulos + Reto Final Integrador (Sin contenido aburrido)",
      "Acceso DE POR VIDA a la plataforma",
      "6 Bonos exclusivos totalmente gratis - INCLUIDOS",
      "Plantilla mini-CRM en hoja de cálculo para seguimiento de clientes"
    ],
    faq: [
      {
        q: "¿Necesito experiencia previa en ventas para tomar este curso?",
        a: "No. El curso está diseñado para todos los niveles — principiante, intermedio y avanzado. Cada módulo arranca desde lo fundamental y avanza hacia técnicas más sofisticadas."
      },
      {
        q: "¿En cuánto tiempo veo resultados?",
        a: "Desde el primer módulo tendrás herramientas que puedes aplicar ese mismo día. Muchos estudiantes notan mejoras en su tasa de cierre desde la primera semana de aplicar las técnicas."
      },
      {
        q: "¿Puedo estudiar a mi ritmo o hay horario fijo?",
        a: "El curso es 100% pregrabado. Puedes acceder a las clases cuando quieras, desde cualquier dispositivo, sin fechas límite."
      },
      {
        q: "¿El curso sirve para cualquier tipo de producto o servicio?",
        a: "Sí. Las técnicas aplican para emprendedores, freelancers y negocios de cualquier industria. Todo el contenido está basado en principios de venta conversacional, no en un nicho específico."
      }
    ],
    emergencyStopwatch: false,
    presale: false,
    modalOffer: false,
    values: {
      co: {
        oldPrice: 162000,
        newPrice: 89900,
        currency: "COP",
        presale: [
          { fecha: '01/02', valor: '🔥 299.000' },
          { fecha: '15/02', valor: '😍 329.000' },
          { fecha: '28/02', valor: '🙂 359.000' },
          { fecha: '10/03', valor: '🔷 399.000' },
        ]
      },
      ve: {
        oldPrice: 34500,
        newPrice: 23850,
        currency: "Bs",
        presale: [
          { fecha: '01/02', valor: '🔥 900' },
          { fecha: '15/02', valor: '😍 999' },
          { fecha: '28/02', valor: '🙂 1.100' },
          { fecha: '10/03', valor: '🔷 1.200' },
        ]
      },
      cl: {
        oldPrice: 37400,
        newPrice: 27300,
        currency: "CLP",
        presale: [
          { fecha: '01/02', valor: '🔥 24.000' },
          { fecha: '15/02', valor: '😍 26.000' },
          { fecha: '28/02', valor: '🙂 28.000' },
          { fecha: '10/03', valor: '🔷 30.000' },
        ]
      },
      mx: {
        oldPrice: 700,
        newPrice: 509,
        currency: "MXN",
        presale: [
          { fecha: '01/02', valor: '🔥 490' },
          { fecha: '15/02', valor: '😍 530' },
          { fecha: '28/02', valor: '🙂 560' },
          { fecha: '10/03', valor: '🔷 590' },
        ]
      },
      pe: {
        oldPrice: 142,
        newPrice: 101,
        currency: "PEN",
        presale: [
          { fecha: '01/02', valor: '🔥 95' },
          { fecha: '15/02', valor: '😍 100' },
          { fecha: '28/02', valor: '🙂 108' },
          { fecha: '10/03', valor: '🔷 115' },
        ]
      },
      us: {
        oldPrice: 110,
        newPrice: 39,
        currency: "$",
        presale: [
          { fecha: '01/02', valor: '🔥 30' },
          { fecha: '15/02', valor: '😍 37' },
          { fecha: '28/02', valor: '🙂 45' },
          { fecha: '10/03', valor: '🔷 55' },
        ]
      }
    },
    modules: [
      {
        id: 1,
        title: "Módulo 1: El WhatsApp como canal de ventas",
        content: "Entiende por qué WhatsApp vende diferente a cualquier otro canal y los errores que matan una venta en los primeros 10 segundos.",
        lessons: [
          { id: 1, title: "WhatsApp Business Vs WhatsApp normal como canal de ventas", youtubeId: "" },
          { id: 2, title: "Las fases del cliente: sin lenguaje corporal ni urgencia natural", youtubeId: "" },
          { id: 3, title: "Errores comunes que matan la venta en los primeros mensajes", youtubeId: "" },
        ],
      },
      {
        id: 2,
        title: "Módulo 2: Primera impresión (Los primeros 3 mensajes)",
        content: "Domina la apertura de conversación que engancha sin sonar a bot. Estructura del mensaje de bienvenida perfecto.",
        lessons: [
          { id: 4, title: "Estructura del mensaje de bienvenida perfecto. Empatía y conexión", youtubeId: "" },
          { id: 5, title: "Personalización rápida sin perder tiempo", youtubeId: "" },
          { id: 6, title: "La regla de los 5 minutos que define la conversión", youtubeId: "" },
        ],
      },
      {
        id: 3,
        title: "Módulo 3: Tono, empatía y lenguaje que vende",
        content: "Aprende a identificar los 4 perfiles de cliente y a adaptar tu tono. Uso correcto de emojis, audios y notas de voz.",
        lessons: [
          { id: 7, title: "Los 4 tonos de cliente: apurado, indeciso, desconfiado, curioso, imponente", youtubeId: "" },
          { id: 8, title: "Uso correcto de emojis, audios y notas de voz", youtubeId: "" },
          { id: 9, title: "Errores de redacción que generan desconfianza.", youtubeId: "" },
        ],
      },
      {
        id: 4,
        title: "Módulo 4: Preguntas que califican y hacen avanzar la venta",
        content: "Deja de informar y empieza a diagnosticar. El método de las 3 preguntas clave antes de hablar de precio.",
        lessons: [
          { id: 10, title: "El método de las 3 preguntas antes de dar el precio", youtubeId: "" },
          { id: 11, title: "Cómo detectar el verdadero dolor, deseo o urgencia del cliente", youtubeId: "" },
          { id: 12, title: "Cómo evitar el error de 'vomitar' el catálogo", youtubeId: "" },
        ],
      },
      {
        id: 5,
        title: "Módulo 5: Manejo de objeciones ⭐ (El módulo estrella)",
        content: "Respuestas probadas para las 6 objeciones más comunes. Scripts editables para cada situación.",
        lessons: [
          { id: 13, title: "Objeciones de precio: 'Está caro' y 'Lo vi más barato'", youtubeId: "" },
          { id: 14, title: "Objeciones de decisión: 'Lo voy a pensar' y 'Le pregunto a mi pareja'", youtubeId: "" },
          { id: 15, title: "Objeciones de dinero y silencio total", youtubeId: "" },
          { id: 16, title: "Técnica completa: Validar → Reencuadrar → Cerrar", youtubeId: "" },
        ],
      },
      {
        id: 6,
        title: "Módulo 6: Técnicas de cierre para WhatsApp",
        content: "Cierre por alternativa, por urgencia genuina, asumido y de resumen. Cómo pedir el pago sin fricción.",
        lessons: [
          { id: 17, title: "Cierre por alternativa y cierre asumido", youtubeId: "" },
          { id: 18, title: "Cierre por urgencia genuina y cierre de resumen", youtubeId: "" },
          { id: 19, title: "Cómo pedir el pago sin generar fricción", youtubeId: "" },
        ],
      },
      {
        id: 7,
        title: "Módulo 7: Clientes fríos y que dejan en visto",
        content: "Recupera conversaciones que parecían perdidas con una secuencia de seguimiento probada.",
        lessons: [
          { id: 20, title: "Cuándo y cómo reactivar sin sonar desesperado", youtubeId: "" },
          { id: 21, title: "Secuencia de 3 mensajes de seguimiento (día 1, 3 y 7)", youtubeId: "" },
          { id: 22, title: "Qué hacer con el cliente que solo pide catálogo y desaparece", youtubeId: "" },
        ],
      },
      {
        id: 8,
        title: "Módulo 8: El poder del remarketing en WhatsApp",
        content: "La estrategia más subestimada. No necesitas más tráfico — necesitas rescatar el que ya tienes.",
        lessons: [
          { id: 23, title: "Por qué el remarketing es la estrategia más rentable en WhatsApp", youtubeId: "" },
          { id: 24, title: "Cómo segmentar tu lista: leads fríos, carritos abandonados, clientes antiguos", youtubeId: "" },
          { id: 25, title: "La secuencia ganadora: reactivación suave → valor → oferta con urgencia", youtubeId: "" },
        ],
      },
      {
        id: 9,
        title: "Módulo 9: Métricas — qué medir para vender más",
        content: "Deja de sentir que vendes y empieza a saberlo con datos. Mini-CRM en hoja de cálculo incluido.",
        lessons: [
          { id: 26, title: "Tasa de respuesta, tasa de cierre y tiempo promedio de respuesta", youtubeId: "" },
          { id: 27, title: "Cómo armar tu mini-CRM en una hoja de cálculo", youtubeId: "" },
        ],
      },
      {
        id: 10,
        title: "Reto Final: Simulacro integrador (opcional)",
        content: "Aplica todo lo aprendido en un caso completo de principio a fin — objeciones, seguimiento y cierre incluidos.",
        lessons: [
          { id: 28, title: "Caso completo: del primer mensaje al cierre con objeciones reales", youtubeId: "" },
          { id: 29, title: "Autoevaluación con buenas prácticas", youtubeId: "" },
        ],
      },
    ],
    instructor: {
      name: "Luis Eduardo Nieto",
      bio: "Ingeniero en Informática y Estratega Digital en Dissemp Academy. Durante años me he dedicado a entender no solo la tecnología, sino la psicología detrás de por qué las personas compran. He destilado cientos de conversaciones de ventas fallidas y exitosas para crear este método. Mi objetivo es que dejes de 'informar precios' y empieces a diagnosticar y cerrar ventas con confianza.",
      image: profcursows,
      profession: "INGENIERO EN INFORMÁTICA"
    },
    configCheckout: {
      hook: "PREVENTA — LANZAMIENTO 10 DE OCTUBRE",
     // hook: "Acceso inmediato + Kit de bonus incluido",
      testimony1: "Apliqué la técnica de los primeros 3 mensajes y ese mismo día cerré una venta que tenía fría hace 2 semanas. — María, emprendedora",
      testimony2: "El módulo de objeciones vale el curso completo. Ya no bajo el precio, ahora defiendo el valor. — Carlos José, dueño de negocio online",
      includedCourse: [
        "Acceso al curso completo",
        "9 Módulos + Reto Final Integrador",
        "Acceso DE POR VIDA a la plataforma",
        "30 Scripts de cierre listos para usar",
        "Plantilla mini-CRM descargable",
        "Garantía de satisfacción de 5 días",
      ],
      bottomHook: "Con este curso cerrarás más ventas por WhatsApp sí o sí.",
      topHook: "Aprende HOY a convertir conversaciones de WhatsApp en ventas",
      orderBumps: {
        title: "Agrega a tu inscripción el Manual 'Del primer mensaje al cierre'",
        description: "La guía COMPLETA de la conversación: descubre exactamente qué decir en cada etapa, desde el saludo hasta el cierre, para no perder más ventas. Listo para copiar y pegar en tus conversaciones.",
        values: {
          co: {
            oldPrice: 60000,
            newPrice: 24000,
          },
          ve: {
            oldPrice: 15390,
            newPrice: 4840,
          },
          cl: {
            oldPrice: 17400,
            newPrice: 6940,
          },
          mx: {
            oldPrice: 325,
            newPrice: 130,
          },
          pe: {
            oldPrice: 64,
            newPrice: 26,
          },
          us: {
            oldPrice: 19,
            newPrice: 9,
          }
        }  
      },
    },
    active: true,
    openRegistrations: true
  }

];

export default CourseData;
